/*import { cwColors, cwCategories, cwEngravingColors, cwSymbols } from './cwColors-2.js';*/

(function () {
    "use strict";
    function CWDESIGNSTUDIO() {
        const config = window.cwDesignStudioConfig || {};
        // Everything image-URL related derives from this. Built once at boot, and
        // re-derived by this.refresh() when ColorNet's product editor mutates
        // window.cwDesignStudioConfig in place (`config` above IS that same object,
        // so a fresh derive sees the edited values).
        function deriveCwDS() {
            return {
                productRoot: config.productRoot || '',
                productSEName: config.productSEName || '',
                productPartsVersion: config.partsVersion || '',
                dsVersion: 4,
                productName: config.productName || '',
                cwWindow: window,
                maxProductSize: config.maxSize || 2560,
                brainstormCap: 3,
                imageFormat: (config.partsVersion || '').includes("-webp") ? "webp" : "png",
                hasProductImages: config.hasProductImages || false,
                storeName: config.storeName || '',
                shopifyCdnBase: config.shopifyCdnBase || '',
                uploadLambdaUrl: config.uploadLambdaUrl || '',
                fallbackCartImage: config.fallbackCartImage || '',
                externalAddToCart: config.externalAddToCart || null,
            };
        }
        const cwDS = deriveCwDS();
        this.cwDS = cwDS;
        const canvasImageType = { image: 'image', engraving: 'engraving' };
        const engravingImages = {};
        const cartImages = {};

        this.engravingImages = engravingImages;
        this.cartImages = cartImages;
        this.canvasImageType = canvasImageType;

        let currentRenderController = null;
        const renderGeneration = {};
        let dsEventController = null;

        // Cart image generation is debounced — when user changes colors rapidly we
        // skip generating the cart thumbnail on every change. The latest images per
        // angle are stashed here and processed after a quiet period (or on add-to-cart).
        let cartImageDebounceTimer = null;
        let pendingCartImageData = {};
        const CART_IMAGE_DEBOUNCE_MS = 500;

        // Cart-edit mode: when an edit_line_key is in the URL on page load, we
        // load the design state from that cart line (instead of from ?design=)
        // and rewire the buy button to swap the line on submit (add new, remove
        // old). Empty string means "not editing — normal add-to-cart flow."
        let editLineKey = '';
        // Quantity carried over from the line being edited. The DS product
        // page has no visible qty selector, so without this an edit-and-save
        // would always collapse the line back to qty 1. Default 1 for safety.
        let editLineQuantity = 1;

        // Quote mode: when ColorNet opens the storefront in a popup for a
        // salesperson, the buy button becomes "Add to Quote" and posts a
        // resolved parts list back to ColorNet via postMessage instead of
        // adding to cart. Flag is stashed in sessionStorage at page-load
        // top (see theme.liquid inline capture) so it survives the URL
        // rewrites the DS does on every design change.
        const CN_TARGET_ORIGIN = 'https://colornet.colorware.com';
        function isQuoteMode() {
            return sessionStorage.getItem('cnQuoteMode') === '1' && !!window.opener;
        }

        // Build engraving config lookup from config.parts (keyed by sename)
        let engravingConfig = {};
        if (config.parts) {
            config.parts.forEach(function (part) {
                if (part.type === 'engraving' && part.rawData) {
                    engravingConfig[part.sename] = part.rawData;
                }
            });
        }

        let engTimer;
        let studio;
        let dsInitializing = true;

        this.initMutationObserver = function () {
            // Function to handle mutations
            const mutationHandler = (mutationsList, observer, callback) => {
                if (dsInitializing) return;
                for (let mutation of mutationsList) {
                    if (mutation.type === 'childList') {
                        callback();
                    }
                }
            };

            // Observer for .product__info-container
            const productInfoObserver = new MutationObserver((mutationsList, observer) => {
                mutationHandler(mutationsList, observer, updateProductPriceSub);
            });

            const productInfoElement = document.querySelector(".product__info-container");
            if (productInfoElement) {
                productInfoObserver.observe(productInfoElement, { childList: true, subtree: true });
            }

            // Observer for .js-kit-summary
            const kitSummaryObserver = new MutationObserver((mutationsList, observer) => {
                mutationHandler(mutationsList, observer, updateProductPriceSub2);
            });

            const kitSummaryElement = document.querySelector(".js-kit-summary");
            if (kitSummaryElement) {
                kitSummaryObserver.observe(kitSummaryElement, { childList: true, subtree: true });
            }

            // Observer for .bcpo input[type='checkbox']
            const bcpoObserver = new MutationObserver((mutationsList, observer) => {
                for (let mutation of mutationsList) {
                    if (mutation.type === 'childList') {
                        if (document.querySelector(".bcpo input[type='checkbox']") !== null) {
                            let bcpoEl = document.querySelector(".bcpo");
                            if (bcpoEl) {
                                bcpoEl.addEventListener("change", function (e) {
                                    if (e.target.matches("input")) {
                                        updateProductPrice();
                                    }
                                });
                            }
                            observer.disconnect();
                        }
                    }
                }
            });

            bcpoObserver.observe(document.body, { childList: true, subtree: true });

        };

        function debounce(func, wait) {
            let timeout;
            return function (...args) {
                const context = this;
                clearTimeout(timeout);
                timeout = setTimeout(() => func.apply(context, args), wait);
            };
        }

        function capitalizeWords(string) {
            return string.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
        }


        function getRequestValue(name) {
            if (name = (new RegExp('[?&]' + encodeURIComponent(name) + '=([^&]*)')).exec(location.search))
                return decodeURIComponent(name[1]);
        }

        function slotLeft(panel, slotEl) {
            if (!panel || !slotEl) return 0;
            return slotEl.getBoundingClientRect().left - panel.getBoundingClientRect().left + panel.scrollLeft;
        }
        function snapScrollTo(panel, left, animate) {
            if (!panel) return;
            panel.classList.remove("scrollMode");
            if (Math.abs(panel.scrollLeft - left) < 1) { panel.classList.add("scrollMode"); return; }
            if (!animate) { panel.scrollLeft = left; panel.classList.add("scrollMode"); return; }
            let restored = false;
            const restore = function () {
                if (restored) return;
                restored = true;
                panel.classList.add("scrollMode");
                panel.removeEventListener("scrollend", restore);
            };
            panel.addEventListener("scrollend", restore);
            setTimeout(restore, 800);
            panel.scrollTo({ left: left, behavior: 'smooth' });
        }
        function paletteScroll() {
            let partPanel = document.querySelector(".palette > ul");
            let studioPanel = document.querySelector(".studio > ul");
            let partsScrollLeft = partPanel.scrollLeft;
            let partsWidth = partPanel.offsetWidth;
            let studioScrollLeft = studioPanel.scrollLeft;
            let studioWidth = studioPanel.offsetWidth;
            let curAngle = Math.round(studioScrollLeft / studioWidth) + 1;
            let partItems = partPanel.querySelectorAll(":scope > li");
            let angleNeeded = parseInt(partItems[Math.round(partsScrollLeft / partsWidth)]?.getAttribute("data-angle"));

            if (Number.isFinite(angleNeeded) && curAngle !== angleNeeded) {
                let angleLi = studioPanel.querySelector(`:scope > li.angle${angleNeeded}`);
                let target = angleLi ? slotLeft(studioPanel, angleLi) : parseInt((angleNeeded - 1) * studioWidth, 10);
                snapScrollTo(studioPanel, target, true);
            }
        }

        function showPalettePart(partName, animate) {
            let partPanel = document.querySelector(".palette > ul");
            let targetPart = partPanel.querySelector(`.part-${partName}`);
            snapScrollTo(partPanel, targetPart ? slotLeft(partPanel, targetPart) : 0, animate);
        }

        function buildPalette() {
            if (!config.parts || config.parts.length === 0) return;
            let paletteUl = document.querySelector(".palette > ul");
            if (!paletteUl) return;
            // Clear-first so this is re-runnable (editor refresh). No-op at first boot.
            paletteUl.innerHTML = '';

            config.parts.forEach(function (part) {
                if (part.type === "included") return;

                let li = document.createElement("li");
                let h4 = document.createElement("h4");
                let divIcon = document.createElement("div");
                let spanPartName = document.createElement("span");
                spanPartName.className = "partName";
                let spanColorName = document.createElement("span");
                spanColorName.className = "colorName";
                let spanPrice = document.createElement("span");
                spanPrice.className = "productPartPrice";
                spanPrice.textContent = "$0";
                let spanRemove = document.createElement("span");
                spanRemove.className = "removePartText";
                spanRemove.innerHTML = '<i class="fas fa-trash-alt"></i>';

                h4.appendChild(divIcon);
                h4.appendChild(spanPartName);
                h4.appendChild(spanColorName);
                h4.appendChild(spanPrice);
                h4.appendChild(spanRemove);

                if (part.type === "model") {
                    li.className = "part-variant";
                    li.setAttribute("data-angle", part.angle);
                    h4.setAttribute("data-sename", "variant");
                    li.appendChild(h4);

                    let partOptions = document.createElement("div");
                    partOptions.className = "part-options";
                    let catSection = document.createElement("section");
                    catSection.className = "cat-variant";
                    let catUl = document.createElement("ul");
                    catUl.className = "cat-variant";

                    if (part.colors) {
                        part.colors.forEach(function (color) {
                            let sename = color.sename;
                            let fullSename = color.name.replace(/ /g, '-').toLowerCase();
                            let gcClass = color.name.includes("$") ? " isGCPrice" : "";
                            let swatchLi = document.createElement("li");
                            swatchLi.className = "variantSwatch variant-" + sename + gcClass;
                            swatchLi.title = color.name;
                            swatchLi.setAttribute("data-variant-id", "1484");
                            swatchLi.setAttribute("data-variant-sename", fullSename);
                            swatchLi.setAttribute("data-variant-discount", "");
                            let img = document.createElement("img");
                            img.id = "variant-swatch-" + sename;
                            img.width = 1000;
                            img.height = 600;
                            swatchLi.appendChild(img);
                            swatchLi.appendChild(document.createTextNode(color.name));
                            catUl.appendChild(swatchLi);
                        });
                    }

                    catSection.appendChild(catUl);
                    partOptions.appendChild(catSection);
                    li.appendChild(partOptions);
                } else {
                    li.className = "part-" + part.sename;
                    li.setAttribute("data-angle", part.angle);
                    h4.setAttribute("data-sename", part.sename);
                    li.appendChild(h4);
                    let partOptions = document.createElement("div");
                    partOptions.className = "part-options";
                    li.appendChild(partOptions);
                }

                paletteUl.appendChild(li);
            });
        }

        function buildBuySection() {
            let buySection = document.querySelector("section.buy");
            if (!buySection) return;
            let stickyBtn = buySection.querySelector(".stickyAddToCart");
            if (!stickyBtn) return;

            // Price data attributes
            buySection.setAttribute("data-price", config.compareAtPrice || 0);
            buySection.setAttribute("data-sale-price", config.price || 0);

            // Display price
            let bfPrice = buySection.querySelector(".bfPrice");
            if (bfPrice) bfPrice.textContent = "$" + Math.round(config.price / 100);

            // Lead time
            let shipTime = buySection.querySelector(".bfShippingTime");
            if (shipTime) shipTime.textContent = "Ships in " + (config.leadTime || '');

            // Inventory sold out — only add the element if actually sold out
            if (config.inventoryPolicy === 'deny' && config.inventoryQuantity <= 0) {
                let soldOutDiv = document.createElement("div");
                soldOutDiv.className = "inventorySoldOutWarning";
                soldOutDiv.textContent = "Out of Stock";
                stickyBtn.insertBefore(soldOutDiv, stickyBtn.firstChild);
            }

            // CW: Ready to Ship stock counter, sits to the left of the buy
            // button. It is a scarcity cue, not a stock report. It renders
            // only for products in the ready-to-ship collection, and only
            // while real stock is left, so a count of 0 or less emits nothing
            // at all. Sold out is already covered by the overlay above.
            if (config.readyToShip && config.inventoryQuantity == 1) {
                let qtyDiv = document.createElement("div");
                qtyDiv.className = "buyQty";
                qtyDiv.textContent = "Only " + config.inventoryQuantity + " left!";
                buySection.insertBefore(qtyDiv, stickyBtn);
            }

            // Sale badge — only add if there's a sale
            if (config.compareAtPrice > 0) {
                let saleDiv = buySection.querySelector(".salePrice");
                let saleSpan = saleDiv ? saleDiv.querySelector("span") : null;
                if (saleDiv && saleSpan) {
                    let saleAmount = Math.round((config.compareAtPrice - config.price) / 100);
                    saleSpan.textContent = "$" + saleAmount + " off";
                    saleDiv.style.display = '';
                }
            }
        }

        // Edit mode: rewrite the buy button text from "Add to Cart" to
        // "Update Cart" while preserving the price span. The button structure
        // is: textNode("Add to ") + <span.CartByName>Cart</span> + <span.bfPrice>.
        // We only replace the leading text node so the price keeps updating.
        function flipBuyButtonForEdit() {
            let btn = document.querySelector(".stickyAddToCart");
            if (!btn) return;
            for (let node of btn.childNodes) {
                if (node.nodeType === Node.TEXT_NODE && node.textContent.includes("Add to")) {
                    node.textContent = node.textContent.replace("Add to", "Update");
                    break;
                }
            }
        }

        // Quote mode: rewrite "Add to Cart $X" → "Add to Quote". We hide the
        // price span because ColorNet's UI shows its own totals downstream.
        function flipBuyButtonForQuote() {
            let btn = document.querySelector(".stickyAddToCart");
            if (!btn) return;
            const cartByName = btn.querySelector('.CartByName');
            if (cartByName) cartByName.textContent = 'Quote';
            const bfPrice = btn.querySelector('.bfPrice');
            if (bfPrice) bfPrice.style.display = 'none';
        }

        // Build the parts payload for ColorNet. Ordering matters: parent
        // model SKU FIRST, then configurable color parts (each with any
        // active upcharge as its price), then engravings, then hidden parts
        // and included parts. Every SKU we resolve from the form's hidden
        // *-partnumber inputs — the DS already keeps those current as the
        // customer picks colors, so we just harvest them.
        function buildQuotePartsPayload() {
            const designStateEl = document.getElementById('designState');
            const form = designStateEl ? designStateEl.closest('form') : null;
            const parts = [];
            const seen = new Set();
            function push(sku, qty, price, description) {
                if (!sku) return;
                // Guard against dupes if the same SKU appears via multiple
                // paths (hidden + included, etc). Combine by summing qty.
                const key = sku + '|' + (description || '');
                if (seen.has(key)) return;
                seen.add(key);
                parts.push({ sku: sku, qty: qty || 1, price: price || 0, description: description || '' });
            }

            // 1. Parent/model SKU + base price (first, per ColorNet contract)
            const modelPNEl = document.getElementById('model-partnumber');
            if (modelPNEl && modelPNEl.value) {
                const basePrice = (config.price || 0) / 100;
                const productName = config.productName || '';
                const varEl = document.getElementById('VariantSEName');
                const variantLabel = varEl && varEl.value
                    ? varEl.value.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); })
                    : '';
                const description = variantLabel ? productName + ' - ' + variantLabel : productName;
                push(modelPNEl.value, 1, basePrice, description);
            }

            // 2. Configurable color parts. Each part's assembled SKU lives in
            //    `${partSEName}-partnumber`. If an upcharge checkbox is present
            //    for this part and it's checked, its value is the extra $ this
            //    color choice costs — send that as the part's unit price.
            document.querySelectorAll('.js-kit-group').forEach(function (group) {
                const partSEName = group.getAttribute('data-part-sename');
                const partName = group.getAttribute('data-part-name');
                if (!partSEName) return;
                // Skip the model group here — handled above.
                if (partName === 'Model') return;
                const pnEl = document.getElementById(partSEName + '-partnumber');
                if (!pnEl || !pnEl.value) return;
                // Skip if this "kit group" is actually an engraving container
                // (they carry the same class but engraving parts have their
                // own dedicated inputs handled in step 3).
                if (group.classList.contains('engraving-option')) return;

                const select = group.querySelector('.partColorOptions');
                const colorName = select && select.value ? select.value : '';

                // Upcharge: checkbox is added when Liquid saw an optional
                // part_upcharge for this part_name. Value = upcharge $. When
                // JS toggles it based on the chosen color, `.checked` reflects
                // whether this specific color triggers the upcharge.
                let upcharge = 0;
                const upEl = document.getElementById(partSEName + '-upcharge');
                if (upEl && upEl.checked) {
                    upcharge = parseFloat(upEl.value) || 0;
                }

                push(pnEl.value, 1, upcharge, colorName ? (partName + ': ' + colorName) : partName);
            });

            // 3. Engravings. Only include when the customer actually typed
            //    something — an empty engraving isn't a line item.
            document.querySelectorAll('.engraving-option').forEach(function (engOpt) {
                const partSEName = engOpt.getAttribute('data-part-sename');
                if (!partSEName) return;
                const textEl = document.getElementById('engraving-text-' + partSEName);
                if (!textEl || !textEl.value) return;
                const pnEl = document.getElementById('engraving-part-number-' + partSEName);
                if (!pnEl || !pnEl.value) return;
                const priceEl = document.getElementById('engraving-price-' + partSEName);
                const price = priceEl ? (parseFloat(priceEl.value) || 0) : 0;
                push(pnEl.value, 1, price, 'Engraving: ' + textEl.value);
            });

            // 4. Hidden parts — product metafield-driven, always ship with
            //    the product. properties[_hidden-part-name-NN] pairs with
            //    properties[_hidden-part-number-NN].
            if (form) {
                form.querySelectorAll('input[name^="properties[_hidden-part-number-"]').forEach(function (el) {
                    if (!el.value) return;
                    const m = el.name.match(/^properties\[_hidden-part-number-(\d+)\]$/);
                    if (!m) return;
                    const nameEl = form.querySelector('input[name="properties[_hidden-part-name-' + m[1] + ']"]');
                    push(el.value, 1, 0, nameEl ? nameEl.value : '');
                });

                // 5. Included parts — Liquid emits properties[_<lowercased>]
                //    for parts whose name contains "included". Value is the
                //    SKU, no separate label input.
                form.querySelectorAll('input[type="hidden"]').forEach(function (el) {
                    const m = el.name.match(/^properties\[_([a-z0-9-]+)\]$/);
                    if (!m) return;
                    const key = m[1];
                    if (!key.includes('included')) return;
                    if (!el.value) return;
                    push(el.value, 1, 0, key.replace(/-/g, ' '));
                });
            }

            return parts;
        }

        // Post the resolved parts to ColorNet. Only ever fires the exact
        // origin — never '*'. Echoes the nonce ColorNet minted so it can
        // reject any message that didn't originate from this popup session.
        function postQuoteToColorNet(parts) {
            if (!window.opener) return false;
            const nonce = sessionStorage.getItem('cnNonce') || '';
            try {
                window.opener.postMessage(
                    { type: 'colornet-quote-parts', nonce: nonce, parts: parts },
                    CN_TARGET_ORIGIN
                );
                return true;
            } catch (err) {
                console.error('Quote post to ColorNet failed:', err);
                return false;
            }
        }

        // Quote-mode click handler for the buy button. Builds the payload,
        // posts it, then disables the button to prevent double-sends. The
        // caller (ColorNet) is responsible for closing the popup or moving
        // to the next product.
        function handleQuoteClick() {
            const parts = buildQuotePartsPayload();
            if (!parts || parts.length === 0) {
                console.warn('Quote: no parts to send');
                return;
            }
            const ok = postQuoteToColorNet(parts);
            const btn = document.querySelector('.stickyAddToCart');
            if (!btn) return;
            if (ok) {
                btn.disabled = true;
                btn.classList.add('cwQuoteSent');
                const cartByName = btn.querySelector('.CartByName');
                if (cartByName) cartByName.textContent = 'Sent';
            } else {
                console.error('Quote send failed — button left active for retry');
            }
        }

        function loadPartMap() {
            document.querySelectorAll(".dsPartMap").forEach(function (mapEl) {
                let svgSRC = mapEl.dataset.src;
                let animate = true;
                fetch(svgSRC)
                    .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
                    .then(function (html) {
                        mapEl.innerHTML = html;
                        mapEl.querySelectorAll("svg path").forEach(function (path) {
                            path.addEventListener("click", function () {
                                document.getElementById("cwDesignStudio").classList.remove("allPartsMode");
                                let partName = this.dataset.name;
                                if (partName === undefined) {
                                    partName = this.id;
                                }
                                showPalettePart(partName, animate);
                            });
                        });
                    })
                    .catch(function () { mapEl.innerHTML = ""; });
            });
        }

        function updateDesignURL() {
            const state = {
                baseModel: '', // We'll set this from cwColors
                colors: {},
                engravings: {}
            };
            // Get base model from VariantSEName and cwColors
            const variantSENameEl = document.getElementById('VariantSEName');
            const variantSEName = variantSENameEl ? variantSENameEl.value : '';
            if (variantSEName && cwColors[variantSEName]) {
                state.baseModel = cwColors[variantSEName].partnumber;
            }
            // Collect color selections
            document.querySelectorAll('.js-kit-group').forEach(function (group) {
                const partSEName = group.getAttribute('data-part-sename');
                const select = group.querySelector('.partColorOptions');
                if (select) {
                    const selectedOption = select.querySelector('option:checked');
                    if (selectedOption && selectedOption.getAttribute('data-sename')) {
                        state.colors[partSEName] = selectedOption.getAttribute('data-sename');
                    }
                }
            });
            // Collect engraving data from form order-data fields (source of truth)
            document.querySelectorAll('.engraving-option').forEach(function (engOpt) {
                const groupName = engOpt.getAttribute('data-part-sename');
                const engravingData = {};

                let engTextEl = document.getElementById(`engraving-text-${groupName}`);
                if (engTextEl && engTextEl.value) {
                    engravingData['text'] = engTextEl.value;
                }

                let engColorEl = document.getElementById(`engraving-color-${groupName}`);
                if (engColorEl && engColorEl.value) {
                    engravingData['color'] = engColorEl.value;
                }

                if (Object.keys(engravingData).length > 0) {
                    state.engravings[groupName] = engravingData;
                }
            });
            // Update URL without reloading page, and mirror the same encoded
            // string into the form's _design-state property so the cart line
            // item carries a canonical snapshot we can read back on edit.
            const encodedState = btoa(encodeURIComponent(JSON.stringify(state)));
            const designStateEl = document.getElementById('designState');
            if (designStateEl) designStateEl.value = encodedState;
            const url = new URL(window.location.href);
            url.searchParams.set('design', encodedState);
            window.history.replaceState({}, '', url.toString());
        }

        // Apply a decoded design state object to the form/UI. Shared by
        // loadDesignFromURL (boot from ?design=) and loadDesignFromCartLine
        // (boot from a cart line's _design-state property when editing).
        function applyDesignState(state) {
            try {
                // Apply base model if it exists
                if (state.baseModel) {
                    // Find the variant SEName by partnumber
                    for (const [seName, data] of Object.entries(cwColors)) {
                        if (data.partnumber === state.baseModel) {
                            const varEl = document.getElementById('VariantSEName');
                            if (varEl) {
                                varEl.value = seName;
                                varEl.dispatchEvent(new Event('change', { bubbles: true }));
                            }
                            // Update model-partnumber
                            const modelPN = document.getElementById('model-partnumber');
                            if (modelPN) {
                                const basePartNumber = modelPN.getAttribute('data-basepartnumber');
                                const newPartNumber = basePartNumber.replace('[]', state.baseModel);
                                modelPN.value = newPartNumber;
                            }
                            break;
                        }
                    }
                }

                // Apply colors
                for (const [partSEName, colorSEName] of Object.entries(state.colors || {})) {
                    const select = document.querySelector(`.js-kit-group[data-part-sename="${partSEName}"] .partColorOptions`);
                    if (select) {
                        const option = select.querySelector(`option[data-sename="${colorSEName}"]`);
                        if (option) {
                            select.value = option.value;
                            select.dispatchEvent(new Event('change', { bubbles: true }));
                        }
                    }
                }

                // Apply engravings — write to form fields (source of truth), then sync palette
                for (const [groupName, engravingData] of Object.entries(state.engravings || {})) {
                    // Write to form order-data fields first (source of truth)
                    let engTextEl = document.getElementById(`engraving-text-${groupName}`);
                    let engColorEl = document.getElementById(`engraving-color-${groupName}`);

                    if (engravingData.text && engTextEl) {
                        engTextEl.value = engravingData.text;
                    }
                    if (engravingData.color && engColorEl) {
                        engColorEl.value = engravingData.color;
                    }

                    // Backward compat: old URL format used field names as keys
                    for (const [fieldName, value] of Object.entries(engravingData)) {
                        if (fieldName === 'text' || fieldName === 'color') continue;
                        // Old format stored text under a field name like "color1-text"
                        if (engTextEl && !engTextEl.value) {
                            engTextEl.value = value;
                        }
                    }

                    // Restore the part number too. applyDesignState runs before the
                    // palette is built, so the 'input' dispatch below is a no-op at boot
                    // and partTextChanged never runs for a loaded design — without this
                    // the part number sits at the initial base "ENGRAVING" until the user
                    // re-edits the engraving (the leaked-ENGRAVING bug). Colors are
                    // applied earlier in this function, so the parent color is set.
                    let engPNEl = document.getElementById(`engraving-part-number-${groupName}`);
                    if (engPNEl) syncEngravingPartNumber(engPNEl);

                    // Sync to palette textarea so user sees the restored text
                    let paletteTA = document.querySelector(`.engTextArea-${groupName}`);
                    if (paletteTA && engTextEl) {
                        paletteTA.value = engTextEl.value;
                        paletteTA.dispatchEvent(new Event('input', { bubbles: true }));
                    }
                }
                updateDesignURL();
            } catch (error) {
                console.error('Error applying design state:', error);
            }
        }

        // Decode an encoded design-state string (base64 of URI-encoded JSON)
        // back into a state object. Returns null on parse failure.
        function decodeDesignState(encoded) {
            try {
                return JSON.parse(decodeURIComponent(atob(encoded)));
            } catch (error) {
                console.error('Error decoding design state:', error);
                return null;
            }
        }

        function loadDesignFromURL() {
            const designParam = getRequestValue('design');
            if (!designParam) {
                // If no design parameter, create initial URL state
                updateDesignURL();
                return;
            }
            const state = decodeDesignState(designParam);
            if (state) applyDesignState(state);
        }

        // Load design state for a cart line we're editing. Fetches /cart.js,
        // finds the matching line by key, decodes its _design-state property,
        // applies it. Returns true if the state was successfully applied.
        // If the line is missing (e.g. customer cleared it in another tab) or
        // has no _design-state (added before this feature shipped), returns
        // false so the caller can treat it as a normal fresh-product load.
        function loadDesignFromCartLine(lineKey) {
            return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
                .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
                .then(function (cart) {
                    const line = (cart.items || []).find(function (i) { return i.key === lineKey; });
                    if (!line) {
                        console.warn('Edit line not found in cart:', lineKey);
                        return false;
                    }
                    const encoded = line.properties && line.properties['_design-state'];
                    if (!encoded) {
                        console.warn('Edit line has no _design-state property:', lineKey);
                        return false;
                    }
                    const state = decodeDesignState(encoded);
                    if (!state) return false;
                    // Carry over the original quantity so the swap preserves it.
                    editLineQuantity = parseInt(line.quantity, 10) || 1;
                    applyDesignState(state);
                    return true;
                })
                .catch(function (err) {
                    console.error('loadDesignFromCartLine failed:', err);
                    return false;
                });
        }

        function fixDSImgSize(imgSrc, newSize) {
            let newImgSize, windowWidth = window.innerWidth;

            if (newSize === 0) {
                newImgSize = 2560;
                if (windowWidth < 2010) { newImgSize = 2000; }
                if (windowWidth < 1010) { newImgSize = 1000; }
                if (windowWidth < 650) { newImgSize = 640; }
                if (windowWidth < 510) { newImgSize = 500; }
                if (windowWidth < 330) { newImgSize = 320; }
                if (windowWidth < 110) { newImgSize = 100; }
                if (window.devicePixelRatio > 1.5) {
                    if (newImgSize === 2000) { newImgSize = 2560; }
                    if (newImgSize === 1000) { newImgSize = 2000; }
                    if (newImgSize === 640) { newImgSize = 1000; }
                    if (newImgSize === 500) { newImgSize = 1000; }
                    if (newImgSize === 320) { newImgSize = 640; }
                    if (newImgSize === 100) { newImgSize = 320; }
                }

                if (cwDS.imageFormat === 'webp') {
                    newImgSize = windowWidth >= 1010 ? 2560 : 1000;  // Use 2560 for desktop and 1000 for mobile
                }

            } else {
                newImgSize = newSize;
            }
            if (newImgSize > cwDS.maxProductSize) {
                newImgSize = cwDS.maxProductSize;
            }
            //newImgSize = 2000;
            if (typeof imgSrc === 'undefined') { return imgSrc; }
            imgSrc = imgSrc.replace("size-2560", "size-xxx").replace("size-2000", "size-xxx").replace("size-1000", "size-xxx").replace("size-320", "size-xxx");
            imgSrc = imgSrc.replace("size-500", "size-xxx").replace("size-640", "size-xxx").replace("size-100", "size-xxx").replace("size-xxx", `size-${newImgSize}`);
            return imgSrc;
        }

        function getLines(ctx, text, maxWidth) {
            let words = text.split(" "), lines = [], currentLine = words[0];
            for (let i = 1; i < words.length; i++) {
                let word = words[i], width = ctx.measureText(currentLine + " " + word).width;
                if (width < maxWidth) {
                    currentLine += " " + word;
                } else {
                    lines.push(currentLine);
                    currentLine = word;
                }
            }
            lines.push(currentLine);
            return lines;
        }

        function fillEngravingText(angle, engData, imageScale = 1.0) {
            let lines, imageAngle, groupName, xstart, ystart, maxWidth, fontSize, lineCount, textAlign, lineheight, engContext, engSmallContext, imagesizeW, imagesizeH, finalLines = [], imageSizeRatio;

            groupName = engData.group;

            if (cwEngravingColors[engData.textcolor] === undefined) { return false; }
            //remove emojis
            engData.text = engData.text.replace(/[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{2300}-\u{23FF}\u{2B50}\u{1F004}\u{1F0CF}\u{1F18E}\u{1F191}-\u{1F251}\u{1F600}-\u{1F636}\u{1F645}-\u{1F64F}\u{1F300}-\u{1F641}\u{1F3E0}-\u{1F3F0}\u{25AA}\u{25AB}\u{25FE}\u{25FD}\u{25FB}\u{25FC}\u{2B1B}\u{2B1C}\u{25B6}\u{25C0}\u{1F200}-\u{1F251}\u{0F00}-\u{0FFF}\u{1D400}-\u{1D7FF}]/gu, '');

            lines = engData.text.split('\n');
            imagesizeW = Math.round(2560 * imageScale);;
            imagesizeW = parseInt(imagesizeW, 10);
            imageSizeRatio = imagesizeW / 2560;
            imagesizeH = imagesizeW * 0.6;

            // Read engraving rendering parameters from config
            let engCfg = engravingConfig[groupName] || {};
            xstart = imagesizeW * parseFloat(engCfg.xstart || 0);
            ystart = imagesizeH * parseFloat(engCfg.ystart || 0);
            maxWidth = imagesizeH * parseFloat(engCfg.maxwidth || 0);
            fontSize = imagesizeH * parseFloat(engCfg.fontsize || 0);
            lineCount = parseInt(engCfg.linecount || 0);
            textAlign = engCfg.textalign || "center";

            const rightPadding = textAlign === 'right' ? 2 : 0;

            // Get imageangle transform from config
            // Supports two formats:
            //   Flat: "imageangle1": "transform string" or "hide" or ""
            //   Nested: "imageangles": { "1": { "transform": "...", "adjustRatio": 0.15 } }
            let angleKey = "imageangle" + angle;
            let angleData;
            if (engCfg[angleKey] !== undefined) {
                angleData = engCfg[angleKey];
            } else if (engCfg.imageangles && engCfg.imageangles[angle] !== undefined) {
                angleData = engCfg.imageangles[angle];
            } else {
                return false; // No engraving on this angle
            }

            if (angleData === 'hide') {
                return false; // Explicitly hidden on this angle
            } else if (angleData === '') {
                // Empty string = render straight with no transform
                imageAngle = "";
            } else if (typeof angleData === 'object' && angleData.transform) {
                // Nested format: { transform: "...", adjustRatio: ... }
                imageAngle = angleData.transform;
            } else if (typeof angleData === 'string') {
                // Flat format: direct transform string
                imageAngle = angleData;
            } else {
                imageAngle = "";
            }
            lineheight = fontSize * 1.3;
            engContext = document.createElement("canvas").getContext('2d');
            engContext.canvas.width = imagesizeW;
            engContext.canvas.height = imagesizeH;
            engContext.textBaseline = "middle";
            engContext.textAlign = textAlign;

            engContext.font = `300 ${fontSize}px 'Cabin', 'Font Awesome 6 Pro' `;
            engContext.fillStyle = cwEngravingColors[engData.textcolor].fontcolor;

            engSmallContext = document.createElement("canvas").getContext('2d');
            engSmallContext.canvas.width = maxWidth + rightPadding;
            engSmallContext.canvas.height = lineheight * lineCount;
            engSmallContext.textBaseline = "middle";
            engSmallContext.textAlign = textAlign;
            engSmallContext.font = `300 ${fontSize}px 'Cabin', 'Font Awesome 6 Pro' `;
            engSmallContext.fillStyle = "#000000";

            let smallContextX;
            if (textAlign === "right") {
                smallContextX = maxWidth;
            } else if (textAlign === "left") {
                smallContextX = 0;
            } else { // center
                smallContextX = maxWidth / 2;
            }

            //cwEngravingColors
            if (imageAngle !== "") {
                let imageAngleData, xScale, ySkew, xSkew, yScale, xMove, yMove;
                imageAngleData = imageAngle.split(",");
                xScale = imageAngleData[0];
                xSkew = imageAngleData[2];
                xMove = imageAngleData[4];
                yScale = imageAngleData[3];
                ySkew = imageAngleData[1];
                yMove = imageAngleData[5];

                let adjustRatio = null;
                // Read adjust ratio — supports flat ("imageangleratio1") and nested (angleData.adjustRatio)
                let ratioKey = "imageangleratio" + angle;
                if (engCfg[ratioKey] !== undefined && engCfg[ratioKey] !== null) {
                    let val = parseFloat(engCfg[ratioKey]);
                    if (!isNaN(val)) adjustRatio = val;
                } else if (typeof angleData === 'object' && angleData.adjustRatio !== undefined) {
                    let val = parseFloat(angleData.adjustRatio);
                    if (!isNaN(val)) adjustRatio = val;
                }
                if (adjustRatio !== null) {
                    let renderedWidth = engContext.measureText(engData.text).width;
                    let textOffset = renderedWidth * adjustRatio;
                    xMove = (parseFloat(xMove) + textOffset) * imageSizeRatio;
                    yMove = (parseFloat(yMove) + (textOffset / -10)) * imageSizeRatio;
                } else {
                    xMove = xMove * imageSizeRatio;
                    yMove = yMove * imageSizeRatio;
                }
                engContext.setTransform(xScale, ySkew, xSkew, yScale, xMove, yMove);
            }

            for (let i = 0; i < lines.length; i++) { // Chat GTP optimization
                let tempLines = getLines(engContext, lines[i], maxWidth), extralines = 0;
                // getLines wraps by whole words, so a word that overflows the
                // last allowed line lands on a line that never gets drawn, and
                // the whole word vanishes. Fold any wrapped lines past the limit
                // back onto the last allowed line instead, so the trim loop below
                // removes only the characters that don't fit.
                let linesLeft = lineCount - finalLines.length;
                if (linesLeft > 0 && tempLines.length > linesLeft) {
                    tempLines = tempLines.slice(0, linesLeft - 1).concat(tempLines.slice(linesLeft - 1).join(" "));
                }
                for (let j = 0; j < tempLines.length; j++) {
                    while (engContext.measureText(tempLines[j]).width > maxWidth) {
                        tempLines[j] = tempLines[j].substring(0, tempLines[j].length - 1);
                    }
                    if (finalLines.length < lineCount) {
                        engContext.fillText(tempLines[j], xstart, ystart + ((i + extralines) * lineheight));
                        engSmallContext.fillText(tempLines[j], smallContextX, (lineheight / 2) + ((i + extralines) * lineheight));
                        finalLines.push(tempLines[j]);
                    }
                    extralines++;
                }
            }

            const processedText = finalLines.join('\n');
            // Guard the VISIBLE textbox: only reflow it if its live value still
            // matches the text we just rendered — i.e. no new keystrokes landed
            // during this async render. Otherwise skip, so we never overwrite
            // characters the user is still typing (the dropped-letter bug); the
            // next render reconciles. The hidden order field has no typing race,
            // so it always stays in sync with the trimmed/wrapped result.
            const engTextArea = document.querySelector(`.engTextArea-${groupName}`);
            if (engTextArea && engTextArea.value === engData.text) {
                engTextArea.value = processedText;
            }
            const engTextEl = document.getElementById(`engraving-text-${groupName}`);
            if (engTextEl) engTextEl.value = processedText;

            if (imageAngle === "hide") {
                engContext.clearRect(0, 0, engContext.canvas.width, engContext.canvas.height);
            } else if (imageAngle === "") {
                let imageDataURL = engSmallContext.canvas.toDataURL();
                let base64Image = imageDataURL.split(',')[1];
                engravingImages[`.partdata-imageangle${angle}`] = base64Image;
            }

            return engContext.canvas.toDataURL();
        }

        this.fillEngravingText = fillEngravingText;

        function createCanvasImage(dsImages, angle, imageToUpdate, imagesize) {
            let dsMainContext, tempImageCount, cwAngleImage, tempImages, dsBGContext;
            const isVariantSwatch = imageToUpdate.startsWith('variant-swatch-');

            if (currentRenderController) {
                currentRenderController.abort();
                //clearAllCanvasImages(); // Clear everything when aborting
            } else {
                // Also clear everything when starting a new render sequence
                //clearAllCanvasImages();
            }

            currentRenderController = new AbortController();
            const signal = currentRenderController.signal;
            const myGeneration = (renderGeneration[imageToUpdate] || 0) + 1;
            renderGeneration[imageToUpdate] = myGeneration;

            dsMainContext = document.createElement("canvas").getContext('2d');
            //imagesize = "size-2560";
            tempImageCount = 0;
            cwAngleImage = document.getElementById(imageToUpdate);

            if (cwAngleImage !== null) {
                cwAngleImage.onload = function () {
                    if (imageToUpdate === 'dsAngle1Img') {
                        addBrainstorm(document.getElementById("dsAngle1Img"), "");
                    }
                };
            }
            tempImages = [];
            imagesize = fixDSImgSize("size-2560", imagesize).replace("size-", "");
            dsMainContext.canvas.width = parseInt(imagesize, 10);
            dsMainContext.canvas.height = (parseInt(imagesize, 10) * 0.6);
            dsMainContext.clearRect(0, 0, dsMainContext.canvas.width, dsMainContext.canvas.height);
            dsMainContext.fillStyle = "#FFF";

            let loadImagePromises = [];

            dsImages.forEach(function (imgItem) {
                if (imgItem.type === canvasImageType.image) {
                    loadImagePromises.push(new Promise(resolve => {
                        let tempImage = new Image();
                        tempImage.onload = () => resolve(tempImage);
                        tempImage.src = fixDSImgSize(imgItem.url, imagesize);
                        tempImage.crossOrigin = 'Anonymous';
                    }));
                } else if (imgItem.type === canvasImageType.engraving) {
                    loadImagePromises.push(new Promise(resolve => {
                        let engravingDataURL = fillEngravingText(angle, imgItem);
                        if (!engravingDataURL || engravingDataURL === false) {
                            resolve(null);
                            return;
                        }
                        let tempImage = new Image();
                        tempImage.onload = () => resolve(tempImage);
                        tempImage.src = engravingDataURL;
                        tempImage.crossOrigin = 'Anonymous';
                    }));
                }
            });

            return Promise.all(loadImagePromises).then(images => {
                if (renderGeneration[imageToUpdate] !== myGeneration) return;
                dsMainContext.clearRect(0, 0, dsMainContext.canvas.width, dsMainContext.canvas.height);
                dsMainContext.fillStyle = "#FFFFFF";
                dsMainContext.fillRect(0, 0, dsMainContext.canvas.width, dsMainContext.canvas.height);

                images.filter(img => img != null).forEach(image => {
                    dsMainContext.drawImage(image, 0, 0);
                });
                if (cwAngleImage !== null) {
                    cwAngleImage.src = dsMainContext.canvas.toDataURL("image/webp");
                    if (isVariantSwatch) {
                        let partOpts = cwAngleImage.closest('.part-options');
                        if (partOpts) partOpts.classList.add('swatches-loaded');
                    }
                }
                // Cart image generation is deferred to a debounced helper so rapid
                // color changes don't trigger 4× extra canvases on every interaction.
                if (!isVariantSwatch) {
                    scheduleCartImageGeneration(angle, images);
                }
            }).catch(error => {
                if (error.message === 'Render aborted') {
                    console.log(`Render for angle ${angle} was aborted for newer render`);
                } else {
                    console.error('Error in canvas render:', error);
                }
            })
                .finally(() => {
                    // Clear controller reference if this is the current render
                    if (currentRenderController && currentRenderController.signal === signal) {
                        currentRenderController = null;
                    }
                });;
        }


        function drawDSImages(angle, imageToUpdate, variantID, imageSize) {
            let dsImages = [];
            dsImages.push({ type: canvasImageType.image, url: `${cwDS.productRoot}/parts${cwDS.productPartsVersion}/angle-${angle}/model/size-2560/bg.${cwDS.imageFormat}` });
            document.querySelectorAll(`.variantSwatch.variant-${variantID}`).forEach(function (swatch) {
                let variantSEName = swatch.getAttribute("data-variant-sename");
                if (variantSEName.indexOf("$") < 0) {
                    dsImages.push({ type: canvasImageType.image, url: `${cwDS.productRoot}/parts${cwDS.productPartsVersion}/angle-${angle}/model/size-2560/${variantSEName}.${cwDS.imageFormat}` });
                }
            });

            document.querySelectorAll(".js-kit-group").forEach(function (kitGroup) {
                kitGroup.querySelectorAll(".partColorOptions").forEach(function (selectEl) {
                    let groupName = selectEl.getAttribute("data-group-name");
                    let selected = selectEl.querySelector("option:checked");
                    if (selected) {
                        let colorName = selected.getAttribute("data-sename"), colorObj, ignoreColor, partColorLookup = colorName;
                        if (selected.getAttribute("data-finish") === "skin") { partColorLookup = `${colorName}-skin`; }
                        if (selected.getAttribute("data-finish") === "style") { partColorLookup = `${colorName}-style`; }
                        colorObj = cwColors[partColorLookup];
                        ignoreColor = (colorObj.offoption) ? true : false;
                        if (selected.getAttribute("data-finish") === "show") { ignoreColor = false }
                        if (!ignoreColor) {
                            dsImages.push({ type: canvasImageType.image, url: `${cwDS.productRoot}/parts${cwDS.productPartsVersion}/angle-${angle}/${groupName}/size-2560/${colorName}.${cwDS.imageFormat}` });
                        }
                    }
                });
                // Read engraving data from form order-data fields (source of truth)
                let engPartSEName = kitGroup.getAttribute("data-part-sename");
                if (kitGroup.classList.contains("engraving-option") && engPartSEName) {
                    let engTextEl = document.getElementById(`engraving-text-${engPartSEName}`);
                    let engColorEl = document.getElementById(`engraving-color-${engPartSEName}`);
                    if (engTextEl && engTextEl.value !== "") {
                        let textcolor = engColorEl ? engColorEl.value : "";
                        if (textcolor) {
                            dsImages.push({ type: canvasImageType.engraving, text: engTextEl.value, group: engPartSEName, textcolor: textcolor });
                        }
                    }
                }
            });
            dsImages.push({ type: canvasImageType.image, url: `${cwDS.productRoot}/parts${cwDS.productPartsVersion}/angle-${angle}/model/size-2560/fg.${cwDS.imageFormat}` });
            return createCanvasImage(dsImages, angle, imageToUpdate, imageSize);
        }

        function updatePartNumbers() {
            document.querySelectorAll(`.select.kit-group`).forEach(function (kitGroup) {
                let partSEName = kitGroup.getAttribute("data-part-sename"), partColorLookup;
                let selectEl = kitGroup.querySelector(`.partColorOptions`);
                let selected = selectEl ? selectEl.querySelector("option:checked") : null;
                if (selected) {
                    partColorLookup = selected.getAttribute("data-sename");
                    if (selected.getAttribute("data-finish") === "skin") { partColorLookup = `${partColorLookup}-skin` }
                    if (selected.getAttribute("data-finish") === "style") { partColorLookup = `${partColorLookup}-style` }
                    let pnEl = document.getElementById(`${partSEName}-partnumber`);
                    let partSelect = document.querySelector(`select.part-${partSEName}`);
                    if (pnEl && partSelect) {
                        pnEl.value = partSelect.getAttribute("data-part-number") + "-" + cwColors[partColorLookup].partnumber;
                    }
                }
            });

            const variantEl = document.getElementById('VariantSEName');
            if (variantEl) { //Shopify logic
                let curModel = variantEl.value;
                let curModelPartNumber = cwColors[curModel].partnumber;
                let modelPN = document.getElementById("model-partnumber");
                if (modelPN) {
                    let modelBasePartNumber = modelPN.getAttribute("data-basepartnumber"), fullPartNumber;
                    fullPartNumber = modelBasePartNumber.replace("[]", curModelPartNumber);
                    modelPN.value = fullPartNumber;
                }
            }
        }

        function renderCartImage(angle, images) {
            let validImages = images.filter(img => img != null);
            if (validImages.length === 0) return;

            let tmpCanvas = document.createElement('canvas');
            let tmpCtx = tmpCanvas.getContext('2d');
            let targetWidth = 700;
            let targetHeight = validImages[0].height * (targetWidth / validImages[0].width);
            tmpCanvas.width = targetWidth;
            tmpCanvas.height = targetHeight;
            tmpCtx.fillStyle = "#FFFFFF";
            tmpCtx.fillRect(0, 0, targetWidth, targetHeight);
            validImages.forEach(image => {
                tmpCtx.drawImage(image, 0, 0, targetWidth, targetHeight);
            });

            let quality = 1;
            let resizedDataURL = tmpCanvas.toDataURL('image/jpeg', quality);
            while (resizedDataURL.length / 1024 > 95 && quality > 0.1) {
                quality -= 0.1;
                resizedDataURL = tmpCanvas.toDataURL('image/jpeg', quality);
            }
            cartImages[`.cart-image-angle-${angle}`] = resizedDataURL;
        }

        function scheduleCartImageGeneration(angle, images) {
            // Stash the latest loaded images for this angle. If user changes color
            // again before the timer fires, the entry is overwritten with the newer
            // images and only the latest set ends up rendered to a cart thumbnail.
            pendingCartImageData[angle] = images;
            clearTimeout(cartImageDebounceTimer);
            cartImageDebounceTimer = setTimeout(flushCartImageGeneration, CART_IMAGE_DEBOUNCE_MS);
        }

        function flushCartImageGeneration() {
            // Generate cart images for any angles with pending data. Called on
            // debounce timer fire OR synchronously from addToCart() to ensure the
            // latest cart image is ready before form submission.
            clearTimeout(cartImageDebounceTimer);
            cartImageDebounceTimer = null;
            Object.keys(pendingCartImageData).forEach(function (a) {
                renderCartImage(a, pendingCartImageData[a]);
            });
            pendingCartImageData = {};
        }

        async function drawAllDSImages() {
            if (currentRenderController) {
                currentRenderController.abort();
            }

            // Determine current variant once, used for swatch prioritization
            let variantID = '';
            const variantEl = document.getElementById('VariantSEName');
            if (variantEl) variantID = variantEl.value.replace("$", "");

            // Determine currently visible angle so we can render it first
            let studioPanel = document.querySelector(".studio > ul");
            let curAngle = 1;
            if (studioPanel && studioPanel.offsetWidth > 0) {
                curAngle = Math.round(studioPanel.scrollLeft / studioPanel.offsetWidth) + 1;
            }

            let anglesArray = [];
            document.querySelectorAll(".kit-group").forEach(function (kitGroup) {
                let groupAngle = kitGroup.getAttribute("data-angle");
                if (groupAngle && anglesArray.indexOf(groupAngle) === -1 && groupAngle !== "") {
                    anglesArray.push(groupAngle);
                }
            });
            if (anglesArray.length === 0) {
                anglesArray.push("1");
            }

            // Update part numbers immediately (cheap, doesn't depend on canvas work)
            updatePartNumbers();

            // PRIORITY 1: Render the visible angle first so the user sees their change ASAP
            try {
                await drawDSImages(curAngle, `dsAngle${curAngle}Img`, variantID, 2560);
            } catch (e) { /* abort or render error handled inside */ }

            // PRIORITY 2: Other angles in parallel (visible has CPU dibs, browser is now caught up)
            let otherAnglePromises = [];
            anglesArray.forEach(function (angleVal) {
                if (parseInt(angleVal) !== parseInt(curAngle)) {
                    otherAnglePromises.push(drawDSImages(angleVal, `dsAngle${angleVal}Img`, variantID, 2560));
                }
            });
            try {
                await Promise.all(otherAnglePromises);
            } catch (e) { /* per-render errors handled inside */ }

            // PRIORITY 3: Currently-selected variant swatch (so it's ready when palette is viewed)
            let activeSwatch = document.querySelector(`.variantSwatch.variant-${variantID}`);
            if (activeSwatch) {
                let swSEName = activeSwatch.getAttribute("data-variant-sename");
                if (swSEName) {
                    swSEName = swSEName.replace("$", "");
                    try {
                        await drawDSImages(1, `variant-swatch-${swSEName}`, swSEName, 1000);
                    } catch (e) { /* */ }
                }
            }

            // PRIORITY 4: Other variant swatches in parallel — deferred so they don't
            // compete for CPU with anything the user is actively viewing
            let otherSwatchPromises = [];
            document.querySelectorAll(".variantSwatch").forEach(function (swatch) {
                let swSEName = swatch.getAttribute("data-variant-sename");
                if (!swSEName) return;
                swSEName = swSEName.replace("$", "");
                if (swSEName !== variantID) {
                    otherSwatchPromises.push(drawDSImages(1, `variant-swatch-${swSEName}`, swSEName, 1000));
                }
            });
            try {
                await Promise.all(otherSwatchPromises);
            } catch (e) { /* */ }
        }

        function addBrainstorm(imgSrc, colors) {
            let bsUl = document.querySelector(".brainstorm ul");
            let bsLi = document.createElement("li");
            let bsImg = document.createElement("img");
            bsImg.src = imgSrc.src;

            bsImg.dataset.url = colors;
            bsLi.append(bsImg);
            bsLi.className = "mediaLoadDesign";

            if (imgSrc.src) {
                let currentLiCount = bsUl.querySelectorAll("li:not(.addDesign)").length;
                if (currentLiCount >= 4) {
                    let firstLi = bsUl.querySelector("li:not(.addDesign)");
                    if (firstLi) firstLi.remove();
                }
                bsUl.appendChild(bsLi);
            }
            // Click handling via event delegation in attachDSEvents
        }


        function updateSelectedColorsPalette() {
            let palette = document.querySelector(".palette"), partList = document.querySelectorAll(".kit-group"), urlToPushHistory, partsURL = "", partFilesUrl = "";

            const variantEl = document.getElementById('VariantSEName');
            if (variantEl) { //Shopify logic
                let selectedColor, partName = "Model", selectedColorSE, variantSEName, partSEName = "variant";
                variantSEName = variantEl.value;
                if (variantSEName !== undefined) {
                    variantSEName = variantSEName.replace("$", "");
                }
                const varSwatch = document.querySelector(`.variantSwatch.variant-${variantSEName}`);
                selectedColor = varSwatch ? varSwatch.title : '';
                selectedColorSE = varSwatch ? varSwatch.getAttribute("data-variant-sename") : undefined;
                if (selectedColorSE !== undefined) {
                    selectedColorSE = selectedColorSE.replace("$", "");
                }
                const pPartName = palette.querySelector(`.part-${partSEName} h4 .partName`);
                if (pPartName) pPartName.innerHTML = `${partName}: `;
                const pColorName = palette.querySelector(`.part-${partSEName} h4 .colorName`);
                if (pColorName) pColorName.innerHTML = selectedColor;
                const pDiv = palette.querySelector(`.part-${partSEName} h4 div`);
                if (pDiv) pDiv.className = ` colorSwatch color${selectedColorSE} `;
                palette.querySelectorAll(`.part-${partSEName} .part-options .variantSwatch`).forEach(el => el.classList.remove("isSelected"));
                const activeVarSwatch = palette.querySelector(`.part-${partSEName} .part-options .variant-${selectedColorSE}.variantSwatch`);
                if (activeVarSwatch) activeVarSwatch.classList.add("isSelected");
                let varRadioButton = document.querySelector(`input[name^="Style"][value="$${selectedColorSE}"]`);

                if (varRadioButton) {
                    varRadioButton.checked = true;

                    try {
                        let event = new Event('change', { bubbles: true });
                        varRadioButton.dispatchEvent(event);
                    } catch (error) {
                        console.error('Error dispatching change event or calling onVariantChange:', error);
                    }
                }


                if (partFilesUrl !== "") { partFilesUrl = `${partFilesUrl}*`; }
                if (selectedColorSE !== undefined) {
                    partFilesUrl = `${partFilesUrl}model/${selectedColorSE}`;
                }
            }
            partList.forEach(function (partEl) {
                let partSelect, partName, partSEName, textAreas, partPrice = 0;
                partSelect = partEl.querySelector(".partColorOptions");
                partName = partEl.getAttribute("data-part-name");
                partSEName = partEl.getAttribute("data-part-sename");
                textAreas = partEl.querySelectorAll(".partTextOptions");

                let selected = partSelect ? partSelect.querySelector("option:checked") : null;
                if (selected) {
                    let selectedColor = selected.getAttribute("data-name"), selectedColorSE = selected.getAttribute("data-sename"), curlocation, colorObj, ignoreColor, partColorLookup = selectedColorSE, upchargeCheckbox;
                    const pPartName = palette.querySelector(`.part-${partSEName} h4 .partName`);
                    if (pPartName) pPartName.innerHTML = `${partName}: `;
                    const pColorName = palette.querySelector(`.part-${partSEName} h4 .colorName`);
                    if (pColorName) pColorName.innerHTML = selectedColor;
                    const pDiv = palette.querySelector(`.part-${partSEName} h4 div`);
                    if (pDiv) { pDiv.className = ` colorSwatch color${selectedColorSE} `; pDiv.innerHTML = ` `; }
                    palette.querySelectorAll(`.part-${partSEName} .part-options .colorSwatch`).forEach(el => el.classList.remove("isSelected"));
                    const activeSwatch = palette.querySelector(`.part-${partSEName} .part-options .color${selectedColorSE}.colorSwatch`);
                    if (activeSwatch) activeSwatch.classList.add("isSelected");
                    palette.querySelectorAll(`.part-${partSEName}`).forEach(el => el.classList.remove("offOptionSelected"));

                    if (selected.getAttribute("data-finish") === "skin") { partColorLookup = `${selectedColorSE}-skin` }
                    if (selected.getAttribute("data-finish") === "style") { partColorLookup = `${selectedColorSE}-style` }
                    colorObj = cwColors[partColorLookup];
                    ignoreColor = (colorObj.offoption) ? true : false;
                    upchargeCheckbox = document.querySelector('.js-upcharge-checkbox[data-part-name="' + partName + '"]');
                    if (upchargeCheckbox) {
                        if (!ignoreColor) {
                            partPrice = parseInt(upchargeCheckbox.value, 10);//.data("price");
                        }

                        if ((ignoreColor && upchargeCheckbox.checked) || (!ignoreColor && !upchargeCheckbox.checked)) {
                            upchargeCheckbox.click();
                        }


                    }
                    if (partPrice > 0) {
                        const pPrice = palette.querySelector(`.part-${partSEName} h4 .productPartPrice`);
                        if (pPrice) pPrice.innerHTML = `$${partPrice}`;
                    } else {
                        const pPrice = palette.querySelector(`.part-${partSEName} h4 .productPartPrice`);
                        if (pPrice) pPrice.innerHTML = ``;
                    }

                    if (selected.getAttribute("data-finish") === "show") { ignoreColor = false }
                    if (!ignoreColor) {
                        if (partFilesUrl !== "") { partFilesUrl = `${partFilesUrl}*`; }
                        partFilesUrl = `${partFilesUrl}${partSEName}/${selectedColorSE}`;
                        //curlocation
                    } else {
                        palette.querySelectorAll(`.part-${partSEName}`).forEach(el => el.classList.add("offOptionSelected"));
                    }
                }
                textAreas.forEach(function (textAreaEl) {
                    let selectedColor = "None", selectedColorSE = "none", objTextArea, textPriceDelta = 0, colorObj, partColorLookup, ignoreColor, upchargeCheckbox;
                    palette.querySelectorAll(`.part-${partSEName}`).forEach(el => el.classList.add("offOptionSelected"));
                    upchargeCheckbox = document.querySelector('.js-upcharge-checkbox[data-part-name="' + partName + '"]');
                    if (upchargeCheckbox && upchargeCheckbox.checked) {
                        upchargeCheckbox.click();
                    }
                    // Read engraving state from form order-data fields (source of truth)
                    let engTextEl = document.getElementById(`engraving-text-${partSEName}`);
                    let engColorEl = document.getElementById(`engraving-color-${partSEName}`);
                    if (engTextEl && engTextEl.value !== "" && engColorEl && engColorEl.value) {
                        selectedColorSE = engColorEl.value;
                        // Derive display name from color sename
                        if (selectedColorSE === "white-text") selectedColor = "White Text";
                        else if (selectedColorSE === "black-text") selectedColor = "Black Text";
                        else selectedColor = selectedColorSE;

                        partColorLookup = selectedColorSE;
                        colorObj = cwColors[partColorLookup];
                        if (colorObj !== undefined) {
                            ignoreColor = (colorObj.offoption) ? true : false;

                            if (upchargeCheckbox) {
                                if ((ignoreColor && upchargeCheckbox.checked) || (!ignoreColor && !upchargeCheckbox.checked)) {
                                    upchargeCheckbox.click();
                                }
                                if (!ignoreColor) {
                                    textPriceDelta = parseInt(upchargeCheckbox.value, 10);
                                }
                            }
                            palette.querySelectorAll(`.part-${partSEName}`).forEach(el => el.classList.remove("offOptionSelected"));
                        }
                    }
                    const pPartName = palette.querySelector(`.part-${partSEName} h4 .partName`);
                    if (pPartName) pPartName.innerHTML = `${partName}: `;
                    const pColorName = palette.querySelector(`.part-${partSEName} h4 .colorName`);
                    if (pColorName) pColorName.innerHTML = selectedColor;
                    const pPrice = palette.querySelector(`.part-${partSEName} h4 .productPartPrice`);
                    if (pPrice) pPrice.innerHTML = `$${textPriceDelta}`;
                    const pDiv = palette.querySelector(`.part-${partSEName} h4 div`);
                    if (pDiv) pDiv.className = ` colorSwatch color${selectedColorSE} `;

                    toggleMustPaintMessage(partSEName);
                });

            });
            let requiredSKUs = [];
            document.querySelectorAll(`.kit-group`).forEach(function (kitGroup) {
                const isOptional = kitGroup.getAttribute('data-optional') === 'true';
                const skuNeeded = kitGroup.getAttribute('data-sku-needed');
                if (isOptional) {
                    // Check if there is a select list in this group
                    const selectList = kitGroup.querySelector('select');
                    if (selectList) {
                        // Get the selected option
                        const selectedOpt = selectList.querySelector('option:checked');
                        const selectedOptionSEName = selectedOpt ? selectedOpt.getAttribute('data-sename') : null;
                        const partName = kitGroup.getAttribute('data-part-name');
                        const selectedValue = selectList.value;
                        const colorObj = cwColors[selectedOptionSEName];
                        let isOffOption = false;
                        if (colorObj && colorObj.offoption === 'true') {
                            isOffOption = true;
                        }
                        if (!isOffOption && skuNeeded) {
                            requiredSKUs.push(skuNeeded);
                        }
                    }
                    // Handle text areas
                    const textAreasList = kitGroup.querySelectorAll('textarea[data-self-sename$="-text"]');
                    let nonEmptyTextAreaFound = false;
                    for (let i = 0; i < textAreasList.length; i++) {
                        if (textAreasList[i].value.trim() !== '') {
                            nonEmptyTextAreaFound = true;
                            break; // replaces jQuery's return false
                        }
                    }
                    if (nonEmptyTextAreaFound) {
                        requiredSKUs.push(skuNeeded);
                    }
                }
            });
            updateProductPrice();
        }

        function colorSwatchSelected() {
            let partSEName = this.parentElement.dataset.partsename;
            // The click handler is bound to .part-options li, which includes non-swatch
            // elements like the engraving textarea's li. If we don't have a partSEName,
            // this click bubbled up from something that isn't a color swatch — bail out.
            if (!partSEName) return;

            let selectEl = document.querySelector(`select.part-${partSEName}`);
            if (selectEl) {
                selectEl.value = this.dataset.value;
                selectEl.dispatchEvent(new Event("change", { bubbles: true }));
            }
            document.querySelectorAll(`textarea.paletteEngArea[data-parentsename='${partSEName}']`).forEach(function (ta) {
                runEngUpdate(ta);
            });
            updateSelectedColorsPalette();

            // Re-anchor on the edited part — palette stays put (already on this part),
            // studio scrolls to the part's angle via paletteScroll's normal sync.
            // This handles the case where the user swiped to a different angle but
            // the part they edited isn't visible there.
            showPalettePart(partSEName, true);
        }

        function partTextChanged(textElement) {
            let parentPart, parentPartColor, colorObj, partName;
            partName = textElement.getAttribute("data-partsename");
            parentPart = textElement.getAttribute("data-parentsename");
            let parentSelect = document.querySelector(`.partColorOptions.part-${parentPart}`);
            let parentSelected = parentSelect ? parentSelect.querySelector("option:checked") : null;
            if (parentSelected) {
                parentPartColor = parentSelected.getAttribute("data-sename");
            }
            // NOTE: removed a redundant `textElement.innerHTML = textElement.value`
            // that used to be here — writing innerHTML on a <textarea> being edited is
            // pointless (everything below reads textElement.value) and risky. The actual
            // dropped-character bug ("Test" -> "Tst") was the async write-back in
            // fillEngravingText overwriting in-flight typing; that's now guarded there.
            colorObj = cwColors[parentPartColor];
            if (textElement.value === '') {
                for (const prop in engravingImages) {
                    if (engravingImages.hasOwnProperty(prop)) {
                        delete engravingImages[prop];
                    }
                }
            }
            if (colorObj !== undefined) {
                document.querySelectorAll(`.part-${partName}`).forEach(el => { if (el.value !== undefined) el.value = ""; });
                let pdEl = document.querySelector(`.part-${partName}.partdata-${colorObj.engravingtext}`);
                if (pdEl) pdEl.value = textElement.value;
            }

            if (textElement.value === '' || !colorObj || colorObj.engravingtext === 'no-engraving') {


                let epEl = document.getElementById(`engraving-price-${partName}`);
                if (epEl) epEl.value = "";
                let etEl = document.getElementById(`engraving-text-${partName}`);
                if (etEl) etEl.value = "";
                let epnEl = document.getElementById(`engraving-part-number-${partName}`);
                if (epnEl) epnEl.value = "";
                let ecEl = document.getElementById(`engraving-color-${partName}`);
                if (ecEl) ecEl.value = "";

            } else {

                let generatedPartNumber;
                try {
                    // This can fail if color data is incomplete
                    let epnEl = document.getElementById(`engraving-part-number-${partName}`);
                    let basePN = epnEl ? epnEl.getAttribute("data-base-part-number") : 'ENGRAVING';

                    // 1. Check if we have a valid colorObj and a valid target engraving color
                    if (colorObj && colorObj.engravingtext !== 'no-engraving' && cwColors[colorObj.engravingtext]) {
                        let suffix = cwColors[colorObj.engravingtext].partnumber;
                        generatedPartNumber = `${basePN}-${suffix}`;
                    } else {
                        // 2. If it's 'no-engraving' or missing, return an empty string as requested
                        generatedPartNumber = '';
                    }

                } catch (error) {
                    // Log the actual error that's been causing the bug
                    if (typeof gtag !== 'undefined') {
                        gtag('event', 'engraving_generation_error', {
                            'event_category': 'design_studio_error',
                            'event_label': 'partnumber_generation_failed',
                            'error_message': error.message,
                            'part_name': partName,
                            'parent_color': parentPartColor,
                            'color_obj_exists': colorObj !== undefined,
                            'engraving_text_exists': colorObj?.engravingtext !== undefined
                        });
                    }
                    console.error('Failed to generate part number:', error);
                    generatedPartNumber = '';
                    //return; // Exit early - don't update with bad data
                }


                try {
                    if (generatedPartNumber !== 'ENGRAVING-BLK' && generatedPartNumber !== 'ENGRAVING-WHI') {
                        if (typeof gtag !== 'undefined') {
                            gtag('event', 'engraving_partnumber_bug', {
                                'event_category': 'design_studio_error',
                                'event_label': 'incomplete_partnumber',
                                'part_name': partName,
                                'parent_part': parentPart,
                                'parent_color': parentPartColor || 'undefined',
                                'color_obj_exists': colorObj !== undefined,
                                'generated_partnumber': generatedPartNumber,
                                'non_interaction': true
                            });
                        }
                        console.warn('⚠️ Engraving bug detected:', {
                            partName: partName,
                            parentPartColor: parentPartColor,
                            colorObj: colorObj,
                            generatedPartNumber: generatedPartNumber
                        });
                    }
                } catch (error) {
                    // Log error in validation logic
                    if (typeof gtag !== 'undefined') {
                        gtag('event', 'engraving_validation_error', {
                            'event_category': 'design_studio_error',
                            'event_label': 'validation_exception',
                            'error_message': error.message,
                            'part_name': partName,
                            'non_interaction': true
                        });
                    }
                    console.error('Error in engraving validation:', error);
                }

                let epEl2 = document.getElementById(`engraving-price-${partName}`);
                let upchargeEl = document.getElementById(`${partName}-upcharge`);
                if (epEl2 && upchargeEl) epEl2.value = upchargeEl.value;
                let etEl2 = document.getElementById(`engraving-text-${partName}`);
                if (etEl2) etEl2.value = textElement.value;
                let epnEl2 = document.getElementById(`engraving-part-number-${partName}`);
                if (epnEl2) epnEl2.value = generatedPartNumber;
                let ecEl2 = document.getElementById(`engraving-color-${partName}`);
                if (ecEl2) ecEl2.value = colorObj.engravingtext;
            }
        }

        // Recompute an engraving part's color + part number from its parent part's
        // selected color, WITHOUT touching the engraving text. Mirrors the part-number
        // logic in partTextChanged. Used as a safety sync in the two places where the
        // text can be set without partTextChanged running (design restore + add-to-cart),
        // so the order can never carry the bare base "ENGRAVING" value.
        function syncEngravingPartNumber(epnEl) {
            if (!epnEl) return;
            const container = epnEl.parentElement;
            const textEl = container ? container.querySelector('[id^="engraving-text-"]') : null;
            const colorEl = container ? container.querySelector('[id^="engraving-color-"]') : null;
            const hasText = textEl && textEl.value !== '';
            if (!hasText) {
                epnEl.value = '';
                if (colorEl) colorEl.value = '';
                return;
            }
            const basePN = epnEl.getAttribute('data-base-part-number') || 'ENGRAVING';
            const parentSEName = container ? container.getAttribute('data-parentsename') : null;
            const parentSelect = parentSEName ? document.querySelector(`.partColorOptions.part-${parentSEName}`) : null;
            const parentSelected = parentSelect ? parentSelect.querySelector('option:checked') : null;
            const parentColor = parentSelected ? parentSelected.getAttribute('data-sename') : null;
            const colorObj = parentColor ? cwColors[parentColor] : null;
            if (colorObj && colorObj.engravingtext !== 'no-engraving' && cwColors[colorObj.engravingtext]) {
                epnEl.value = `${basePN}-${cwColors[colorObj.engravingtext].partnumber}`;
                if (colorEl) colorEl.value = colorObj.engravingtext;
            } else {
                epnEl.value = '';
                if (colorEl) colorEl.value = '';
            }
        }

        function toggleMustPaintMessage(partSEName) {
            let engTextEl = document.querySelector(`.palette .engTextArea-${partSEName}`);
            let parentSEName = engTextEl ? engTextEl.getAttribute("data-parentsename") : undefined, parentColor, textColor;
            if (parentSEName === undefined) { return false; }

            let parentSelect = document.querySelector(`.partColorOptions.part-${parentSEName}`);
            let parentSelected = parentSelect ? parentSelect.querySelector("option:checked") : null;
            if (parentSelected) {
                parentColor = parentSelected.getAttribute("data-sename");
            }

            textColor = cwColors[parentColor].engravingtext;
            if (textColor === "no-engraving") {
                document.querySelectorAll(`.palette .part-${partSEName}`).forEach(el => { el.classList.remove("disableEngraving", "allowEngraving"); el.classList.add("disableEngraving"); });
                document.querySelectorAll(`.part-${partSEName} textarea`).forEach(el => el.value = "");
            } else {
                document.querySelectorAll(`.palette .part-${partSEName}`).forEach(el => { el.classList.remove("disableEngraving", "allowEngraving"); el.classList.add("allowEngraving"); });
            }
        }

        function checkLastPartLogic() {
            let partPanel = document.querySelector(".palette > ul");
            if (!partPanel) return;
            let mainPalette = document.querySelector(".palette");
            if (!mainPalette) return;
            // We're on the last part when there's no room left to scroll
            // forward. Use the browser's own scroll geometry (scrollWidth =
            // total scrollable content width, scrollLeft + clientWidth =
            // furthest pixel currently visible). A small tolerance absorbs
            // sub-pixel rounding from smooth-scroll animations and
            // device-pixel-ratio differences.
            const tolerance = 5;
            const visibleRight = partPanel.scrollLeft + partPanel.clientWidth;
            if (visibleRight >= partPanel.scrollWidth - tolerance) {
                mainPalette.classList.add("onLastPart");
            } else {
                mainPalette.classList.remove("onLastPart");
            }
        }

        function symbolSelected() {
            let partSEName, curText, engTextArea, startPos, endPos, newCursorPos;
            partSEName = this.parentElement.dataset.partsename;
            engTextArea = document.querySelector(`.engTextArea-${partSEName}`);
            if (!engTextArea) return;
            startPos = engTextArea.selectionStart;
            endPos = engTextArea.selectionEnd;
            curText = engTextArea.value;

            engTextArea.value = curText.substring(0, startPos) + this.dataset.code + curText.substring(endPos, curText.length);

            newCursorPos = startPos + this.dataset.code.length;
            engTextArea.selectionStart = newCursorPos;
            engTextArea.selectionEnd = newCursorPos;

            engTextArea.dispatchEvent(new Event("input", { bubbles: true }));
            runEngUpdate(engTextArea);
            engTextArea.focus();
        }

        function movePreviousPart() {
            let partPanel = document.querySelector(".palette > ul");
            let partsScrollLeft = partPanel.scrollLeft;
            let partsWidth = partPanel.offsetWidth;
            partPanel.classList.toggle("scrollMode");
            partPanel.scrollTo({ left: partsScrollLeft - partsWidth, behavior: 'smooth' });
            partPanel.addEventListener("scrollend", function handler() {
                partPanel.classList.toggle("scrollMode");
                partPanel.removeEventListener("scrollend", handler);
            });
        }

        function moveNextPart() {
            let mainPalette = document.querySelector(".palette");
            let partPanel = document.querySelector(".palette > ul");
            let partsScrollLeft = partPanel.scrollLeft;
            let partsWidth = partPanel.offsetWidth;
            let newScrollLeft = partsScrollLeft + partsWidth;

            if (mainPalette.classList.contains("onLastPart")) {
                toggleAllParts();
                return false;
            }

            partPanel.classList.toggle("scrollMode");
            partPanel.scrollTo({ left: newScrollLeft, behavior: 'smooth' });
            partPanel.addEventListener("scrollend", function handler() {
                partPanel.classList.toggle("scrollMode");
                partPanel.removeEventListener("scrollend", handler);
            });
        }

        function toggleAllParts() {
            document.getElementById("cwDesignStudio").classList.toggle("allPartsMode");
        }

        function updateProductPriceSub2() {
            updateProductPrice();
        }
        function updateProductPriceSub() {
            updateProductPrice();
        }
        function updateProductPrice() {
            let totalPrice = 0;
            let priceEl = document.querySelector("product-info .price__regular .price-item");
            if (priceEl && priceEl.innerHTML !== undefined) {
                let totalPriceText = priceEl.innerHTML.trim();
                totalPrice = parseFloat(totalPriceText.replace(/[^\d.]/g, ''));
            } else if (config.price) {
                totalPrice = config.price / 100;
            } else {
                return;
            }
            let totalUpcharge = 0.0;
            document.querySelectorAll('.js-upcharge-checkbox:checked').forEach(function (cb) {
                let partPrice = cb.value;
                totalUpcharge += parseFloat(partPrice);
            });
            let upchargesEl = document.getElementById("product-up-charges");
            if (upchargesEl) upchargesEl.value = parseFloat(totalUpcharge);
            totalPrice += parseFloat(totalUpcharge);
            document.querySelectorAll(".bfPrice").forEach(el => el.innerHTML = "$" + totalPrice.toFixed(0));
        };

        // Engraving render cadence. Rendering reloads the studio images, so while
        // the user is typing we hold off rendering until they either pause (idle)
        // or have entered enough characters to be worth a refresh — instead of
        // rendering on every keystroke. Pairs with the guard in fillEngravingText,
        // which is what actually prevents typed characters from being overwritten.
        const ENG_RENDER_IDLE_MS = 300;    // render this long after the last input
        const ENG_RENDER_CHAR_FLUSH = 8;   // ...or sooner once this many inputs queue
        let engRenderPending = 0;
        let engRenderIdleTimer = null;
        let engRenderTextArea = null;

        // Run the engraving update now. Used directly for discrete actions (color
        // pick, symbol insert, clear). Cancels any pending scheduled render.
        function runEngUpdate(textArea) {
            clearTimeout(engRenderIdleTimer);
            engRenderIdleTimer = null;
            engRenderPending = 0;
            const ta = textArea || engRenderTextArea;
            if (!ta) return;
            partTextChanged(ta);
            drawAllDSImages();
            updateSelectedColorsPalette();
            // Sync the URL + #designState so engraving text is captured in
            // ?design= and the _design-state cart property. Without this,
            // engraving text is invisible to share-by-URL and cart-edit.
            updateDesignURL();
        }

        // Schedule an engraving update for live typing: render after a quiet gap,
        // or sooner once enough keystrokes have queued so it never feels dead.
        function scheduleEngUpdate(textArea) {
            engRenderTextArea = textArea;
            engRenderPending++;
            if (engRenderPending >= ENG_RENDER_CHAR_FLUSH) {
                runEngUpdate(textArea);
                return;
            }
            clearTimeout(engRenderIdleTimer);
            engRenderIdleTimer = setTimeout(runEngUpdate, ENG_RENDER_IDLE_MS);
        }

        function disablePaletteScroll() {
            let partPanel = document.querySelector(".palette > ul");
            if (partPanel) partPanel.classList.remove("scrollMode");
        }
        function enablePaletteScroll() {
            let partPanel = document.querySelector(".palette > ul");
            if (partPanel) partPanel.classList.add("scrollMode");
        }

        function applyGalleryColors() {
            let colorCode = this.querySelector("img")?.dataset.url;
            window.scrollTo({ top: 0, behavior: 'smooth' });
            //loadColorsFromCode(colorCode);
        }
        function selectPartHeading() {
            let headingParentSEName = this.getAttribute("data-sename"), animate = false;
            toggleAllParts();
            showPalettePart(headingParentSEName, animate);
        }

        function clearEngraving() {
            let engPartSEName = this.getAttribute("data-partsename"), engPartTextArea = document.querySelector(`.engTextArea-${engPartSEName}`);
            if (engPartTextArea) engPartTextArea.value = "";
            //engravingImages = {};
            for (const prop in engravingImages) {
                if (engravingImages.hasOwnProperty(prop)) {
                    delete engravingImages[prop];
                }
            }
            //updateTextAreas(engPartTextArea);
            runEngUpdate(engPartTextArea);
        }

        function removePart(e) {
            // The trash icon lives inside the part <h4>, whose click handler
            // (selectPartHeading) exits all-parts mode and jumps into the part. Stop
            // the click from bubbling so deleting a part stays in all-parts view.
            if (e) e.stopPropagation();
            let parent = this.closest(".hasOffOption");
            if (parent) {
                let offOpt = parent.querySelector(".isOffOption");
                if (offOpt) offOpt.click();
                let engClear = parent.querySelector(".engClear");
                if (engClear) engClear.click();
            }
            return false;
        }

        function setCSSProperties() {

            let swatchSize, paletteColumns;
            if (window.matchMedia("(orientation: portrait)").matches) {
                swatchSize = getComputedStyle(document.documentElement).getPropertyValue('--colorswatchwidthPortrait').replace('px', '');
                document.documentElement.style.setProperty('--colorswatchwidth', `${swatchSize}px`);
                // you're in PORTRAIT mode
            } else {
                swatchSize = getComputedStyle(document.documentElement).getPropertyValue('--colorswatchwidthLandscape').replace('px', '');
                document.documentElement.style.setProperty('--colorswatchwidth', `${swatchSize}px`);
            }
            let partOptionsEl = document.querySelector(".part-options");
            // Column count = how many swatches fit across, rounded down to an even
            // number so colors wrap in pairs. offsetWidth is sufficient now that the
            // CSS centering padding actually applies (see designstudio-4-4.css,
            // ".part-options ul" — the padding-top/bottom fix).
            let partWidth = partOptionsEl ? partOptionsEl.offsetWidth : 0;
            // OPTIONAL HARDENING (disabled — not currently needed): measure with
            // getBoundingClientRect().width (precise/fractional) instead of offsetWidth
            // (rounded to a whole pixel). offsetWidth can round up by <1px and make the
            // chosen even count ~1px too wide to fit, so the last swatch wraps alone at
            // certain window widths. If you ever see a solo wrap at a specific width,
            // enable the line below and remove the offsetWidth line above.
            // let partWidth = partOptionsEl ? partOptionsEl.getBoundingClientRect().width : 0;
            paletteColumns = Math.floor(Math.floor(partWidth / swatchSize) / 2) * 2;
            document.documentElement.style.setProperty('--column', paletteColumns);

            let trueVH = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${trueVH}px`);

            // --vvh: 1% of the visible viewport (excludes the on-screen keyboard
            // on iOS). When no keyboard is up, it equals window.innerHeight.
            // Used by .engraving-focused to keep studio + textarea + symbols
            // visible when the keyboard appears.
            let vv = window.visualViewport;
            let vvh = vv ? vv.height : window.innerHeight;
            document.documentElement.style.setProperty('--vvh', `${vvh * 0.01}px`);
            document.documentElement.style.setProperty('--keyboard-vh', `${vvh}px`);

            let titleEl = document.querySelector(`.title h3`);
            let productTitleLength = titleEl ? titleEl.textContent.length : 0;
            document.documentElement.style.setProperty('--productTitleLength', `${productTitleLength}`);
        }
        function variantSelect() {
            const newVariantSEName = this.getAttribute("data-variant-sename");
            let varEl = document.getElementById('VariantSEName');
            if (varEl) varEl.value = newVariantSEName;

            let discount = this.getAttribute("data-variant-discount");
            if (discount) {
                let salePriceEl = document.querySelector(`.salePrice span`);
                if (salePriceEl) salePriceEl.innerHTML = `$${discount} off`;
            }

            drawAllDSImages();
            updateSelectedColorsPalette();
            updateDesignURL();
        }
        function addToCart() {

            // Quote mode short-circuit: hand off to ColorNet instead of the
            // Shopify cart flow. Fires only when the popup was opened by
            // ColorNet with quoteMode=1 and window.opener still exists.
            if (isQuoteMode()) {
                handleQuoteClick();
                return;
            }

            try {
                // Flush pending typed text into the order fields if the user typed and
                // hit Add to Cart before the render scheduler fired (the 300ms window),
                // so the last few characters aren't lost. partTextChanged is synchronous
                // (no re-render, no cart-image race). Trimming only happens on the async
                // render, so typing past the red box and checking out instantly could
                // carry untrimmed text — an accepted edge per the priority on the common
                // (within-bounds) case.
                if (engRenderIdleTimer && engRenderTextArea) {
                    clearTimeout(engRenderIdleTimer);
                    engRenderIdleTimer = null;
                    engRenderPending = 0;
                    partTextChanged(engRenderTextArea);
                }

                // Last line of defense: recompute every engraving part number from its
                // parent color before the order goes out, so a stale base "ENGRAVING"
                // (e.g. from a restored design that never ran partTextChanged) can never
                // reach the cart. Only touches color + part number, never the text.
                document.querySelectorAll('[id^="engraving-part-number-"]').forEach(function (epnEl) {
                    let before = epnEl.value;
                    syncEngravingPartNumber(epnEl);
                    let siblingText = epnEl.parentElement ? epnEl.parentElement.querySelector('[id^="engraving-text-"]') : null;
                    let hasEngravingText = siblingText ? siblingText.value : '';

                    // Still report when we had to correct a bare "ENGRAVING" — so the
                    // GA counter keeps tracking how often the upstream race occurs.
                    if (hasEngravingText && before === 'ENGRAVING') {
                        if (typeof gtag !== 'undefined') {
                            gtag('event', 'engraving_partnumber_corrected', {
                                'event_category': 'design_studio_error',
                                'event_label': 'addtocart_base_partnumber_fixed',
                                'element_id': epnEl.id,
                                'corrected_to': epnEl.value,
                                'non_interaction': false
                            });
                        }
                        console.warn('Corrected stale engraving part number at add-to-cart:', epnEl.id, before, '->', epnEl.value);
                    }
                });
            } catch (e) {
                // Silently fail - don't block add to cart
                console.warn('Engraving part-number sync failed:', e);
            }

            let stickyBtn = document.querySelector(".stickyAddToCart");
            if (stickyBtn && !stickyBtn.classList.contains("CheckoutClicked")) {
                if (document.querySelectorAll(".inventorySoldOutWarning").length === 0) {
                    stickyBtn.classList.add("CheckoutClicked");


                    // engravingImages is still populated for internal tools (e.g. print app)
                    // but no longer written to form fields — the cart image already includes
                    // engraving composited in, and the old .partdata-imageangle* textareas
                    // that received base64 data have been removed as part of form simplification.

                    // If the user clicks add-to-cart within the cart-image debounce window,
                    // flush any pending cart image generation now so we send the latest image.
                    if (cartImageDebounceTimer) {
                        flushCartImageGeneration();
                    }

                    let cartImageEl = document.getElementById('cartImage');
                    for (const [key, value] of Object.entries(cartImages)) {
                        if (key === ".cart-image-angle-1") {
                            if (cartImageEl) cartImageEl.value = value;
                        }
                    }

                    const triggerAddToCart = () => {
                        if (cartImageEl) cartImageEl.value = "";

                        // Edit flow: bypass Shopify's product-form custom element and
                        // do the swap manually (add new line, remove old line, redirect).
                        // Add-then-remove order is intentional — if the add fails
                        // (e.g. out of stock), the original line stays untouched.
                        if (editLineKey) {
                            // Anchor on #designState (lives inside the buy-buttons
                            // form) rather than action=*/cart/add* — there can be
                            // multiple forms on the page hitting /cart/add (sticky
                            // add, recommendations quick-buy, etc.) and we need to
                            // be sure we're posting the buy-buttons form with all
                            // its color/engraving/property inputs.
                            let designStateEl = document.getElementById('designState');
                            let form = designStateEl ? designStateEl.closest('form') : null;
                            if (!form) {
                                console.error('Edit: buy-buttons form not found, falling back to normal add');
                                editLineKey = '';
                            } else {
                                // Build the /cart/add.js JSON payload by hand — the
                                // form-encoded properties[Foo] path has been silently
                                // dropping properties in our setup. JSON with an
                                // explicit properties object is the documented and
                                // reliable shape.
                                let variantIdEl = form.querySelector('[name="id"]');
                                let payload = {
                                    id: variantIdEl ? variantIdEl.value : '',
                                    // Use the quantity captured from the cart line we're
                                    // editing, not the form's default qty (always 1).
                                    quantity: editLineQuantity || 1,
                                    properties: {}
                                };
                                form.querySelectorAll('[name^="properties["]').forEach(function (el) {
                                    let m = el.name.match(/^properties\[(.+)\]$/);
                                    if (!m) return;
                                    // Unchecked checkboxes (the upcharge boxes) still carry
                                    // their price in .value. FormData leaves them out, so
                                    // this hand-built payload must too, or every cart edit
                                    // sends "X Up Charge" for parts that were never upcharged.
                                    if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
                                    // Skip empty values so we don't pollute the cart
                                    // line with blank properties (matches the cart
                                    // Liquid's blank-filter behavior).
                                    if (el.value === '' || el.value === null) return;
                                    payload.properties[m[1]] = el.value;
                                });
                                fetch('/cart/add.js', {
                                    method: 'POST',
                                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                                    body: JSON.stringify(payload)
                                })
                                    .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
                                    .then(function () {
                                        return fetch('/cart/change.js', {
                                            method: 'POST',
                                            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                                            body: JSON.stringify({ id: editLineKey, quantity: 0 })
                                        });
                                    })
                                    .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
                                    .then(function () { window.location.href = '/cart'; })
                                    .catch(function (err) {
                                        console.error('Edit swap failed:', err);
                                        // Re-enable the button so the user can retry. Original
                                        // cart line is still intact (add-then-remove ordering).
                                        let sb = document.querySelector(".stickyAddToCart");
                                        if (sb) sb.classList.remove("CheckoutClicked");
                                    });
                                return;
                            }
                        }

                        if (typeof cwDS.externalAddToCart === 'function') {
                            cwDS.externalAddToCart();
                            return;
                        }
                        let productForm = document.querySelector('product-form');
                        if (productForm && !productForm.submitButton) {
                            productForm.submitButton = productForm.querySelector('[type="submit"]');
                        }
                        let addBtn = document.querySelector(".js-add-to-cart-button");
                        if (addBtn) addBtn.click();
                        let submitBtn = document.querySelector(".product-form__submit");
                        if (submitBtn) submitBtn.click();
                    };
                    if (!cwDS.hasProductImages) { //skip this step for images with a product image

                        //const lambdaUrl = 'https://ecl2plowwqejrwhhhpw2tuo7zi0lmutv.lambda-url.us-east-1.on.aws/'; // Original Base URL
                        //const lambdaUrl = 'https://dh43w5v2ii7cciqd3limza3ax40xvjpv.lambda-url.us-east-1.on.aws/'; // PROD Alias URL
                        const lambdaUrl = cwDS.uploadLambdaUrl || 'https://dh43w5v2ii7cciqd3limza3ax40xvjpv.lambda-url.us-east-1.on.aws/';
                        const cdnBase = cwDS.shopifyCdnBase || 'https://cdn.shopify.com/s/files/1/0791/8367/5687/files/';
                        var imageBlob = cartImageEl ? cartImageEl.value : "";

                        fetch(lambdaUrl, {
                            method: 'POST',
                            body: JSON.stringify({ 
                                image: imageBlob,
                                storeName: cwDS.storeName || ''
                            }),
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                            .then(response => response.json())
                            .then(data => {
                                const imageUrl = data.cdnUrl || `${cdnBase}${data.uniqueFileName.replace(".jpeg", ".jpg")}`;
                                let cartImageFileEl = document.getElementById('cartImageFile');
                                if (cartImageFileEl) cartImageFileEl.value = imageUrl;
                                if (cartImageEl) cartImageEl.value = "";

                                triggerAddToCart();
                            })
                            .catch((error) => {
                                console.error('Error:', error);
                                let cartImageFileEl = document.getElementById('cartImageFile');
                                if (cartImageFileEl) cartImageFileEl.value = "";
                                triggerAddToCart();
                            });
                    } else {
                        triggerAddToCart();
                    }


                }
            }
        }

        function scrollHandler(e) {
            let atSnappingPoint = e.target.scrollLeft % e.target.offsetWidth === 0, timeOut = atSnappingPoint ? 0 : 150;
            clearTimeout(e.target.scrollTimeout);
            e.target.scrollTimeout = setTimeout(function () {
                paletteScroll();
                checkLastPartLogic();
            }, timeOut);
        }

        function brainstorm() {
            // Clear text selection
            if (window.getSelection) {
                if (window.getSelection().empty) {  // Chrome
                    window.getSelection().empty();
                } else if (window.getSelection().removeAllRanges) {  // Firefox
                    window.getSelection().removeAllRanges();
                }
            } else if (document.selection) {  // IE?
                document.selection.empty();
            }


            let partList = document.querySelectorAll(".kit-group:not([data-part-sename='hidden'])");
            let chosenColors = [];

            partList.forEach(function (kitGroup) {
                let selectEl = kitGroup.querySelector(".partColorOptions");
                var options = selectEl ? Array.from(selectEl.querySelectorAll('option')) : [];
                if (options.length > 0) {

                    // Select a random option
                    var selectedOption;
                    if (chosenColors.length < cwDS.brainstormCap) {

                        selectedOption = options[Math.floor(Math.random() * options.length)];
                        chosenColors.push(selectedOption.getAttribute('data-sename'));
                    } else {
                        // Select from chosen colors
                        var chosenColor = chosenColors[Math.floor(Math.random() * chosenColors.length)];
                        var matchingOptions = Array.from(selectEl.querySelectorAll(`option[data-sename="${chosenColor}"]`));

                        // If no options with the chosen color exist in this dropdown, select a random option from all options
                        if (matchingOptions.length === 0) {
                            selectedOption = options[Math.floor(Math.random() * options.length)];
                        } else {
                            selectedOption = matchingOptions[Math.floor(Math.random() * matchingOptions.length)];
                        }
                    }
                    if (selectEl) selectEl.value = selectedOption.value;
                }

            });
            drawAllDSImages();
            updateSelectedColorsPalette();
            updateDesignURL();

        }
        function brainstormMode() {
            document.getElementById("cwDesignStudio").classList.add("brainstormMode");

            // Test GA event tracking
            console.log('🧠 Brainstorm mode activated - sending GA event...');

            if (typeof gtag !== 'undefined') {
                gtag('event', 'brainstorm_mode_activated', {
                    'event_category': 'easter_egg',
                    'event_label': 'triple_click',
                    'non_interaction': true
                });
                console.log('✓ GA event sent');
            } else {
                console.log('✗ gtag not available');
            }
        }


        function tripleClick(callbackFunctionName) {
            var clicks = 0; // counter for clicks
            var delay = 500; // delay in milliseconds for detecting triple click
            return function () {
                clicks++;
                if (clicks === 1) {
                    setTimeout(function () {
                        if (clicks === 3) {
                            callbackFunctionName();
                        }
                        // Reset counter
                        clicks = 0;
                    }, delay);
                }
            };
        }

        function attachDSEvents() {
            if (dsEventController) dsEventController.abort();
            dsEventController = new AbortController();
            const signal = dsEventController.signal;

            // Title triple-click (brainstorm easter egg)
            document.querySelector("section.title")?.addEventListener("click", tripleClick(brainstormMode), { signal });

            // Brainstorm add button
            document.querySelector(".addDesign")?.addEventListener("click", brainstorm, { signal });

            // Color dropdowns → redraw + URL update
            document.querySelectorAll(".partColorOptions").forEach(function (el) {
                el.addEventListener("change", drawAllDSImages, { signal });
                el.addEventListener("change", function () { updateDesignURL(); }, { signal });
            });

            // Kit text areas → redraw + debounced URL update
            document.querySelectorAll(".kit-text-area").forEach(function (el) {
                el.addEventListener("input", drawAllDSImages, { signal });
                el.addEventListener("input", function () {
                    clearTimeout(window.urlUpdateTimer);
                    window.urlUpdateTimer = setTimeout(updateDesignURL, 500);
                }, { signal });
            });

            // Palette color swatches
            document.querySelectorAll(".part-options li").forEach(function (el) {
                el.addEventListener("click", colorSwatchSelected, { signal });
            });

            // Palette textareas → debounced text update
            document.querySelectorAll(".part-options textarea, .part-options .inTextarea").forEach(function (el) {
                el.addEventListener("input", function () { scheduleEngUpdate(this); }, { signal });
            });

            // Textarea mousedown → disable palette scroll
            document.querySelectorAll(".part-options textarea").forEach(function (el) {
                el.addEventListener("mousedown", disablePaletteScroll, { signal });
            });
            document.addEventListener("mouseup", enablePaletteScroll, { signal });

            // Palette nav
            document.querySelector(".palette nav .previousPart")?.addEventListener("click", movePreviousPart, { signal });
            document.querySelector(".palette nav .allParts")?.addEventListener("click", toggleAllParts, { signal });
            document.querySelector(".palette nav .nextPart")?.addEventListener("click", moveNextPart, { signal });

            // Part headings
            document.querySelectorAll(".palette h4").forEach(function (el) {
                el.addEventListener("click", selectPartHeading, { signal });
            });

            // Variant swatches
            document.querySelectorAll(".palette .variantSwatch").forEach(function (el) {
                el.addEventListener("click", variantSelect, { signal });
            });

            // Symbol list
            document.querySelectorAll(".symbolList li").forEach(function (el) {
                el.addEventListener("click", symbolSelected, { signal });
                // Prevent mousedown from blurring the engraving textarea — if it
                // blurs, .engraving-focused is removed, the layout reflows, and
                // the click lands on the wrong target (or nothing). Keeping the
                // textarea focused also keeps the iOS keyboard up.
                el.addEventListener("mousedown", function (e) { e.preventDefault(); }, { signal });
            });

            // Upcharge checkboxes → price update
            document.querySelectorAll(".js-upcharge-checkbox").forEach(function (el) {
                el.addEventListener("change", updateProductPrice, { signal });
            });

            // Brainstorm gallery — event delegation on parent
            let bsUl = document.querySelector(".brainstorm ul");
            if (bsUl) {
                bsUl.addEventListener("click", function (e) {
                    let li = e.target.closest(".mediaLoadDesign");
                    if (li) applyGalleryColors.call(li, e);
                }, { signal });
            }

            // Clear engraving buttons
            document.querySelectorAll(".engClear").forEach(function (el) {
                el.addEventListener("click", clearEngraving, { signal });
            });

            // Remove part buttons
            document.querySelectorAll(".removePartText").forEach(function (el) {
                el.addEventListener("click", removePart, { signal });
            });

            // Add to cart
            document.querySelector(".stickyAddToCart")?.addEventListener("click", addToCart, { signal });

            // Scroll handler ONLY on palette — palette navigation drives the studio.
            // Studio swipes (mobile) are free viewing; they don't pull palette back to
            // the studio's angle and don't trigger paletteScroll's snap-back behavior.
            let paletteUl = document.querySelector(".palette > ul");
            if (paletteUl) paletteUl.addEventListener("scroll", scrollHandler, { signal });

            // Window resize/orientation
            window.addEventListener("orientationchange", setCSSProperties, { signal });
            window.addEventListener("resize", setCSSProperties, { signal });

            // visualViewport resize: fires when the iOS keyboard shows/hides
            // (window.resize doesn't fire for that). Drives --vvh / --keyboard-vh
            // so .engraving-focused can size itself to the visible area.
            if (window.visualViewport) {
                window.visualViewport.addEventListener("resize", setCSSProperties, { signal });
            }

            // Engraving textareas: toggle .engraving-focused on the studio root
            // so CSS can compact the layout (hide title/buy/details/gallery and
            // palette nav) when the iOS keyboard appears. Studio stays at 60vw.
            // On focus we also scroll the page so the design studio is at the
            // top of the viewport — otherwise iOS auto-scrolls to center the
            // textarea, which pushes the studio off-screen.
            let dsRoot = document.getElementById("cwDesignStudio");
            document.querySelectorAll(".paletteEngArea").forEach(function (el) {
                el.addEventListener("focus", function () {
                    if (!dsRoot) return;
                    dsRoot.classList.add("engraving-focused");
                    // The class hide rules are portrait-only, so the scroll
                    // adjustment is portrait-only too — desktop doesn't need
                    // (or want) the page to jump on textarea focus.
                    if (!window.matchMedia("(orientation: portrait)").matches) return;
                    // Defer one frame so the layout settles after the class is
                    // applied (hidden rows collapse), then scroll DS to top.
                    // The +50 offset pulls the DS slightly higher than its
                    // natural top so the studio sits closer to the top edge.
                    requestAnimationFrame(function () {
                        let topPos = dsRoot.getBoundingClientRect().top + window.scrollY;
                        window.scrollTo({ top: topPos + 50, behavior: 'instant' });
                    });
                }, { signal });
                el.addEventListener("blur", function () {
                    if (dsRoot) dsRoot.classList.remove("engraving-focused");
                }, { signal });
            });

            // Engraving "paint part" buttons (moved from createPalette)
            document.querySelectorAll(".engraving-paint-part").forEach(function (el) {
                el.addEventListener("click", function () {
                    showPalettePart(this.dataset.parent, true);
                }, { signal });
            });
        }

        function createPalette() {
            let partList = document.querySelectorAll(".kit-group:not([data-part-sename='hidden'])");
            updateSelectedColorsPalette();
            partList.forEach(function (partEl) {
                let partSelect = partEl.querySelector(".partColorOptions"), partName = partEl.getAttribute("data-part-name"), partSEName = partEl.getAttribute("data-part-sename"), colorArray = [], selectedColorSE;
                let ulColorList, sectionColorList, h5ColorList, colorCategoryNote, textAreas = partEl.querySelectorAll(".partTextOptions");
                document.querySelectorAll(`.part-${partSEName}`).forEach(el => el.classList.remove("hasOffOption"));
                let selectedOpt = partSelect ? partSelect.querySelector("option:checked") : null;
                if (selectedOpt) {
                    selectedColorSE = selectedOpt.getAttribute("data-sename");
                }
                if (partSelect) {
                    Array.from(partSelect.querySelectorAll("option")).forEach(function (optEl) {
                        let partColor = optEl.getAttribute("data-sename"), partColorLookup = partColor, optName = optEl.getAttribute("data-name"), colorObj, isSelectedColor;

                        if (optEl.getAttribute("data-finish") === "skin") { partColorLookup = `${partColor}-skin`; }
                        if (optEl.getAttribute("data-finish") === "style") { partColorLookup = `${partColor}-style`; }

                        colorObj = cwColors[partColorLookup];
                        isSelectedColor = selectedColorSE === partColor;
                        if (colorObj !== undefined) {
                            colorArray.push({
                                category: colorObj.category,
                                displayorder: colorObj.displayorder,
                                sename: partColor,
                                name: optName,
                                value: optEl.value,
                                selected: isSelectedColor,
                                offoption: colorObj.offoption
                            });
                        }
                    });
                }

                for (let i = 0; i < colorArray.length; i++) {
                    let liColor = document.createElement("li"), optionsClasses = "";
                    ulColorList = document.querySelector(`.part-${partSEName} .part-options ul.cat-${colorArray[i].category}`);

                    if (!ulColorList) {
                        sectionColorList = document.createElement("section");
                        sectionColorList.className = `cat-${colorArray[i].category}`;
                        sectionColorList.style.order = cwCategories[colorArray[i].category].displayorder;
                        colorCategoryNote = document.createElement("p");
                        colorCategoryNote.appendChild(document.createTextNode(cwCategories[colorArray[i].category].note));
                        h5ColorList = document.createElement("h5");
                        h5ColorList.appendChild(document.createTextNode(colorArray[i].category));
                        ulColorList = document.createElement("ul");
                        ulColorList.className = `cat-${colorArray[i].category}`;
                        ulColorList.dataset.partsename = partSEName;
                        sectionColorList.appendChild(h5ColorList);
                        sectionColorList.appendChild(ulColorList);
                        if (colorCategoryNote !== '') {
                            sectionColorList.appendChild(colorCategoryNote);
                        }
                        let partOptEl = document.querySelector(`.part-${partSEName} .part-options`);
                        if (partOptEl) partOptEl.appendChild(sectionColorList);
                    }

                    liColor.appendChild(document.createTextNode(colorArray[i].name));
                    if (colorArray[i].selected) {
                        optionsClasses = `isSelected ${optionsClasses}`;
                    }
                    if (colorArray[i].offoption === "true") {
                        optionsClasses = `isOffOption ${optionsClasses}`;
                        document.querySelectorAll(`.part-${partSEName}`).forEach(el => el.classList.add("hasOffOption"));
                        if (colorArray[i].selected) {
                            document.querySelectorAll(`.part-${partSEName}`).forEach(el => el.classList.add("offOptionSelected"));
                        }
                    }
                    liColor.className = `${optionsClasses} colorSwatch color${colorArray[i].sename}  ${colorArray[i].category}`;
                    liColor.title = colorArray[i].name;
                    liColor.dataset.value = colorArray[i].value;
                    liColor.style.order = colorArray[i].displayorder;
                    ulColorList.append(liColor);
                }

                textAreas.forEach(function (taEl) {
                    let parentPartName, partTextArea, liText, partTextClear, liTextClear, removeIcon, liSymbols, ulSymbols, pSymbols, detailsLink, sectionSymbols, divMustPaintMessage, divMustPaintMessageContent, pMustPaintNote, buttonMustPaint;

                    parentPartName = capitalizeWords(partSEName.replace("-engraving", '').replace("-", " "));
                    partTextArea = document.createElement("textarea");

                    partTextArea.dataset.partsename = partSEName;
                    partTextArea.dataset.parentsename = taEl.getAttribute("data-parentsename");

                    partTextArea.className = ` fa inTextarea paletteEngArea engTextArea-${partSEName}`;
                    partTextArea.placeholder = `Enter Custom Engraving Here`;
                    // Build from the form, the design's source of truth. On a
                    // refresh or loaded design the form field already holds the
                    // engraving (the image renders from it), but applyDesignState
                    // runs before this textarea exists, so its palette sync finds
                    // nothing. Without this the box starts empty and the first
                    // keystroke overwrites the saved engraving.
                    let formTextEl = document.getElementById(`engraving-text-${partSEName}`);
                    if (formTextEl) partTextArea.value = formTextEl.value;
                    liText = document.createElement("li");

                    sectionColorList = document.createElement("section");
                    sectionColorList.className = "cat-text";

                    h5ColorList = document.createElement("h5");
                    h5ColorList.appendChild(document.createTextNode(`${partName} Text`));

                    ulColorList = document.createElement("ul");

                    sectionColorList.appendChild(h5ColorList);
                    liText.appendChild(partTextArea);

                    partTextClear = document.createElement("button");
                    liTextClear = document.createElement("li");

                    partTextClear.dataset.partsename = partSEName;
                    partTextClear.dataset.parentsename = taEl.getAttribute("data-parentsename");
                    partTextClear.className = "engClear";


                    removeIcon = document.createElement("i");
                    removeIcon.className = "fas fa-trash-alt";

                    //<i class="fas fa-trash-alt"></i>
                    partTextClear.appendChild(removeIcon);
                    partTextClear.appendChild(document.createTextNode(` Remove`));

                    liTextClear.appendChild(partTextClear);

                    //cwSymbols
                    sectionSymbols = document.createElement("section");
                    ulSymbols = document.createElement("ul");
                    ulSymbols.className = "symbolList";
                    ulSymbols.dataset.partsename = partSEName;
                    for (let symbol in cwSymbols) {
                        liSymbols = document.createElement("li");
                        //liSymbols.className = `fa${cwSymbols[symbol].mod} fa-${symbol} symbol${symbol}`;
                        liSymbols.className = `fa fa-${symbol} symbol${symbol}`;
                        liSymbols.dataset.code = cwSymbols[symbol].code;
                        liSymbols.style.order = cwSymbols[symbol].displayorder;
                        ulSymbols.appendChild(liSymbols);
                    }
                    sectionSymbols.appendChild(ulSymbols);
                    ulColorList.appendChild(liText);
                    ulColorList.appendChild(liTextClear);
                    sectionColorList.appendChild(ulColorList);
                    divMustPaintMessage = document.createElement("div");
                    divMustPaintMessage.className = "mustPaintMessage";
                    divMustPaintMessageContent = document.createElement("div");
                    divMustPaintMessageContent.className = "message-content";
                    pMustPaintNote = document.createElement("p");
                    pMustPaintNote.appendChild(document.createTextNode(`To add engraving, the ${parentPartName} must first be painted. Would you like to paint it now?`));
                    pSymbols = document.createElement("p");
                    pSymbols.className = "engraving-policy-message";
                    pSymbols.appendChild(document.createTextNode(`Engraved items are non-returnable.  `));
                    detailsLink = document.createElement("a");
                    detailsLink.href = "/support";
                    detailsLink.appendChild(document.createTextNode("Details"));
                    pSymbols.appendChild(document.createTextNode(`[`));
                    pSymbols.appendChild(detailsLink);
                    pSymbols.appendChild(document.createTextNode(`]`));
                    sectionSymbols.appendChild(pSymbols);
                    buttonMustPaint = document.createElement("button");
                    buttonMustPaint.className = "engraving-paint-part";
                    buttonMustPaint.dataset.parent = parentPartName.toLowerCase().replace(" ", "-");
                    buttonMustPaint.appendChild(document.createTextNode(` Paint ${parentPartName} `));
                    divMustPaintMessageContent.appendChild(pMustPaintNote);
                    divMustPaintMessageContent.appendChild(buttonMustPaint);
                    divMustPaintMessage.appendChild(divMustPaintMessageContent);

                    let partOptEl = document.querySelector(`.part-${partSEName} .part-options`);
                    if (partOptEl) {
                        partOptEl.appendChild(sectionColorList);
                        partOptEl.appendChild(sectionSymbols);
                        partOptEl.appendChild(divMustPaintMessage);
                    }
                    document.querySelectorAll(`.part-${partSEName}`).forEach(el => el.classList.add("hasOffOption"));
                    document.querySelectorAll(`.part-${partSEName}`).forEach(el => el.classList.add("offOptionSelected"));

                    // Engraving paint-part click binding handled in attachDSEvents
                });
            });
            setCSSProperties();
            attachDSEvents();
        }

        function createStudio() {
            let studioEl = document.querySelector(".studio"), angleArray = [], angleUL, angleLI, angleIMG, angleDIV, dsImageW = fixDSImgSize("size-2560", 0);
            // Clear-first so this is re-runnable (editor refresh). Removes only the
            // angle <ul> this function builds, never anything else in .studio.
            if (studioEl) studioEl.querySelectorAll(":scope > ul").forEach(function (ul) { ul.remove(); });
            let dsEl = document.getElementById("cwDesignStudio");
            document.querySelectorAll(".kit-group").forEach(function (kitGroup) {
                let angle = kitGroup.getAttribute("data-angle");
                if (angle) angleArray[angle - 1] = angle;
            });
            if (angleArray.length === 0) {
                if (document.querySelectorAll(".part-variant").length === 0) {
                    if (dsEl) dsEl.classList.add("dsHasNoParts");
                    document.documentElement.style.setProperty('--leftbgimage', `url(${cwDS.productRoot}/parts${cwDS.productPartsVersion}/angle-1/model/${dsImageW}/fg-left.${cwDS.imageFormat})`);
                    document.documentElement.style.setProperty('--rightbgimage', `url(${cwDS.productRoot}/parts${cwDS.productPartsVersion}/angle-1/model/${dsImageW}/fg-right.${cwDS.imageFormat})`);
                } else {
                    if (dsEl) dsEl.classList.add("dsHasOnePart");
                    document.documentElement.style.setProperty('--leftbgimage', `url(${cwDS.productRoot}/parts${cwDS.productPartsVersion}/angle-1/model/${dsImageW}/fg-left.${cwDS.imageFormat})`);
                    document.documentElement.style.setProperty('--rightbgimage', `url(${cwDS.productRoot}/parts${cwDS.productPartsVersion}/angle-1/model/${dsImageW}/fg-right.${cwDS.imageFormat})`);
                }
                angleArray[0] = 1;
            }


            angleUL = document.createElement("ul");
            angleUL.className = "scrollMode";
            for (let i = 0; i < angleArray.length; i++) {
                angleLI = document.createElement("li");
                angleLI.className = ` angle${angleArray[i]} `;
                angleIMG = document.createElement("img");
                angleIMG.id = `dsAngle${angleArray[i]}Img`;
                angleDIV = document.createElement("div");
                angleDIV.className = "dsPartMap";
                angleDIV.title = cwDS.productName;
                angleDIV.dataset.src = `${cwDS.productRoot}/parts${cwDS.productPartsVersion}/angle-${angleArray[i]}/part-map.svg`;
                angleLI.appendChild(angleIMG);
                angleLI.appendChild(angleDIV);
                angleUL.appendChild(angleLI);
            }
            if (studioEl) studioEl.appendChild(angleUL);
        }

        this.setupDesignStudio = function () {
            let ds = document.getElementById("cwDesignStudio");
            if (!ds) return;
            if (config.limitedEdition) ds.classList.add("isLimitedEdition");
            if (config.noParts) ds.classList.add("dsHasNoParts");
            if (config.maxSize) {
                ds.className = ds.className.replace(/maxProductWidth\d+/, '');
                ds.classList.add("maxProductWidth" + config.maxSize);
            }
            let titleH3 = document.querySelector("section.title h3");
            if (titleH3) titleH3.textContent = config.productName;
            buildBuySection();
            buildPalette();
            setCSSProperties();

            // Everything from createPalette onward must run AFTER design state
            // has been applied to the form. Otherwise createPalette builds the
            // palette from default select values, the right-side palette UI
            // shows defaults, and the studio (which redraws on change events)
            // is the only thing that looks right.
            function continueBoot() {
                createPalette();
                createStudio();
                loadPartMap();
                // Quote-mode UI setup: relabel the buy button once the DS has
                // built out. addToCart itself checks isQuoteMode() at click
                // time, so no need to rebind the click handler.
                if (isQuoteMode()) flipBuyButtonForQuote();

                // Defer the first canvas render until fonts are loaded.
                // Otherwise engraving text gets rasterized in the system
                // fallback (Times New Roman) and stays that way — fonts
                // arriving later don't trigger an automatic canvas redraw.
                // We race document.fonts.ready against a hard timeout so a
                // slow or failed font load can't block the studio from ever
                // rendering. drawOnce gates against a double-render in the
                // (common) case where both signals fire.
                let drawn = false;
                const drawOnce = function () {
                    if (drawn) return;
                    drawn = true;
                    drawAllDSImages();
                };
                if (document.fonts && document.fonts.ready) {
                    document.fonts.ready.then(drawOnce);
                } else {
                    drawOnce();
                }
                // Max wait: render even if fonts never report ready. 1500ms
                // covers cached + fresh-network font loads on all but very
                // slow connections; past that we'd rather show the studio
                // with possibly-wrong-font engraving than a blank canvas.
                setTimeout(drawOnce, 1500);

                attachDSEvents();
                updateSelectedColorsPalette();
                updateProductPrice();
                dsInitializing = false;
                // Fallback: force-show swatch images if rendering is slow
                setTimeout(function () {
                    document.querySelectorAll('.part-variant .part-options').forEach(function (el) {
                        el.classList.add('swatches-loaded');
                    });
                }, 5000);
            }

            // Cart-edit boot: if URL has edit_line_key, load state from the
            // cart line's _design-state property instead of from ?design=.
            // If the cart line is missing or has no _design-state (older line),
            // silently fall back to fresh-product load so the page still works.
            const editKeyParam = getRequestValue('edit_line_key');
            if (editKeyParam) {
                editLineKey = editKeyParam;
                loadDesignFromCartLine(editLineKey).then(function (ok) {
                    if (!ok) {
                        editLineKey = '';            // fall back to normal add flow
                        loadDesignFromURL();
                    } else {
                        flipBuyButtonForEdit();
                    }
                    continueBoot();
                });
            } else {
                loadDesignFromURL();
                continueBoot();
            }
        };
        // ---- Editor hook. Additive: nothing here runs during a normal storefront
        // boot. ColorNet's product editor mutates window.cwDesignStudioConfig in
        // place and then calls window.cwDesignStudio.refresh(scope):
        //   'images'  -> a URL-affecting edit (productRoot / partsVersion / maxSize):
        //                re-derive cwDS, rebuild the studio angle list (new image
        //                URLs + part-map.svg), redraw every angle and swatch.
        //   'rebuild' -> parts changed. The editor has already rebuilt the kit-group
        //                form; mirror continueBoot from buildPalette onward.
        // Deliberately never re-applies ?design= state (loadDesignFromURL): a refresh
        // must draw the CURRENT form selections, not a stale URL design.
        this.refresh = function (scope) {
            Object.assign(cwDS, deriveCwDS());
            // maxSize also drives the wrapper class that setupDesignStudio set at boot.
            let dsEl = document.getElementById("cwDesignStudio");
            if (dsEl && config.maxSize) {
                dsEl.className = dsEl.className.replace(/maxProductWidth\d+/, '');
                dsEl.classList.add("maxProductWidth" + config.maxSize);
            }
            if (scope === 'rebuild') {
                buildPalette();
                setCSSProperties();
                createPalette();
            }
            createStudio();
            loadPartMap();
            if (scope === 'rebuild') {
                attachDSEvents();   // already idempotent: aborts its previous controller
                updateSelectedColorsPalette();
                updateProductPrice();
            }
            return drawAllDSImages();
        };

        this.setupDesignStudio();
        if (document.getElementById("cwDesignStudio")) {
            this.initMutationObserver();
        }
    }
    window.addEventListener('load', function () {
        window.cwDesignStudio = new CWDESIGNSTUDIO();
    });


}());
